export const Logo = () => (
  <svg
    width="156"
    height="45"
    viewBox="0 0 156 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      opacity="0.14"
      cx="23.3777"
      cy="23.0926"
      r="21.0926"
      fill="url(#paint0_linear_22_26737)"
    />
    <path
      d="M38.2821 29.5699V16.1751C38.2821 14.0664 36.6027 12.3569 34.531 12.3569C32.4592 12.3569 30.7798 14.0664 30.7798 16.1751V25.2835C31.1341 24.9408 31.604 24.6562 32.0666 24.817C32.3133 24.9028 32.5332 25.069 32.6338 25.3619C32.7929 25.8254 32.5408 26.3146 32.3154 26.7487L31.2769 28.7485C31.228 28.8424 31.1669 28.9292 31.0952 29.0065C30.8926 29.2245 30.7798 29.5131 30.7798 29.8132V30.4966C30.7798 32.0935 32.0516 33.3881 33.6205 33.3881H34.531C36.6027 33.3881 38.2821 31.6786 38.2821 29.5699Z"
      fill="#9FF9E8"
    />
    <path
      d="M24.7528 29.6986V16.0468C24.7528 13.9411 23.0458 12.2341 20.9401 12.2341C18.8344 12.2341 17.1274 13.9411 17.1274 16.0468V25.3119C17.4874 24.9653 17.968 24.6763 18.4396 24.8415C18.6923 24.93 18.9168 25.1016 19.0163 25.4044C19.1684 25.8674 18.9193 26.3514 18.6938 26.7835L17.6327 28.8173C17.5831 28.9124 17.5208 29.0004 17.4476 29.0789C17.2419 29.2993 17.1274 29.5895 17.1274 29.891V30.578C17.1274 32.198 18.4407 33.5113 20.0607 33.5113H20.9401C23.0458 33.5113 24.7528 31.8043 24.7528 29.6986Z"
      fill="#849EFE"
    />
    <path
      d="M37.9077 20.8459C39.4117 19.342 41.8408 19.3327 43.3333 20.8252C44.8258 22.3178 44.8165 24.7469 43.3126 26.2508L37.055 32.5084C35.551 34.0124 33.1219 34.0216 31.6294 32.5291C30.1369 31.0366 30.1462 28.6075 31.6501 27.1036L37.9077 20.8459Z"
      fill="#10EAED"
    />
    <path
      d="M18.2853 13.3849C19.7716 11.8985 22.1815 11.8985 23.6679 13.3849C25.1542 14.8712 25.1542 17.2811 23.6678 18.7675L10.074 32.3613C8.58764 33.8477 6.17778 33.8477 4.69142 32.3613C3.20506 30.875 3.20506 28.4651 4.69142 26.9787L18.2853 13.3849Z"
      fill="url(#paint1_linear_22_26737)"
    />
    <g filter="url(#filter0_bd_22_26737)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8665 13.7449C17.4019 14.3766 17.1274 15.1569 17.1274 16.0012V25.27C17.1346 25.2631 17.1417 25.2563 17.149 25.2495L23.652 18.7446C24.3075 18.0889 24.6744 17.2538 24.7528 16.3973V16.0012C24.7528 15.5794 24.6843 15.1736 24.5578 14.7942C24.3748 14.2671 24.0729 13.7722 23.652 13.3511C22.1631 11.8618 19.749 11.8618 18.2601 13.3511L17.8665 13.7449Z"
        fill="url(#paint2_linear_22_26737)"
      />
    </g>
    <path
      d="M31.7023 13.5258C33.2307 11.9973 35.7088 11.9973 37.2372 13.5258C38.7656 15.0542 38.7656 17.5323 37.2372 19.0607L23.5736 32.7242C22.0452 34.2527 19.5671 34.2527 18.0387 32.7242C16.5103 31.1958 16.5103 28.7177 18.0387 27.1893L31.7023 13.5258Z"
      fill="url(#paint3_linear_22_26737)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.9726 32.344C24.4627 31.6878 24.7529 30.8734 24.7529 29.9913V20.4753C24.7456 20.4824 24.7382 20.4894 24.7308 20.4964L18.0179 27.1854C17.3412 27.8597 16.9625 28.7184 16.8816 29.5991V29.9913C16.8816 30.535 16.9918 31.0528 17.1912 31.5239C17.3825 31.9623 17.6581 32.373 18.0179 32.7315C19.5549 34.263 22.0468 34.263 23.5837 32.7315L23.9726 32.344Z"
      fill="url(#paint4_linear_22_26737)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.5181 32.1105C37.9984 31.4723 38.2822 30.6838 38.2822 29.8306V20.4755C38.2748 20.4824 38.2674 20.4894 38.2599 20.4963L31.5472 27.0624C30.8705 27.7243 30.4918 28.5672 30.4109 29.4318V29.8306C30.4109 30.2635 30.484 30.6798 30.6187 31.0682C30.8082 31.5935 31.1177 32.0866 31.5472 32.5067C33.0842 34.0101 35.5761 34.0101 37.113 32.5067L37.5181 32.1105Z"
      fill="url(#paint5_linear_22_26737)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.396 13.9079C30.931 14.547 30.6567 15.3338 30.6567 16.1847V25.6387C30.664 25.6317 30.6713 25.6248 30.6786 25.6178L37.2865 18.9902C37.9526 18.3222 38.3255 17.4713 38.4051 16.5987V16.1847C38.4051 15.8178 38.3541 15.4628 38.2588 15.1265C38.0808 14.5293 37.7568 13.9666 37.2865 13.495C35.7736 11.9776 33.3206 11.9776 31.8077 13.495L31.396 13.9079Z"
      fill="url(#paint6_linear_22_26737)"
    />
    <path
      d="M70.3 18.896C71.1926 18.896 72.0021 19.0518 72.7287 19.3635C73.476 19.6751 74.1091 20.1218 74.6281 20.7035C75.147 21.2852 75.5518 21.9812 75.8424 22.7915C76.133 23.581 76.2783 24.4744 76.2783 25.4716V35.1637H72.7598V26.0014C72.7598 24.7964 72.4692 23.8511 71.888 23.1655C71.3067 22.4799 70.4868 22.1371 69.4281 22.1371C68.4317 22.1371 67.6325 22.4487 67.0305 23.072C66.4285 23.6953 66.0757 24.4848 65.9719 25.4405V25.534V35.1637H62.4533V26.0014C62.4533 24.7964 62.1523 23.8511 61.5504 23.1655C60.9691 22.4799 60.2011 22.1371 59.2462 22.1371C58.1252 22.1371 57.2326 22.511 56.5684 23.259C55.9249 23.9861 55.6031 24.9107 55.6031 26.0326V35.1637H52.1157V19.1765H55.4163V21.2956C55.8314 20.5892 56.4023 20.0179 57.1288 19.5816C57.8761 19.1245 58.8414 18.896 60.0246 18.896C61.1456 18.896 62.142 19.1453 63.0138 19.6439C63.8857 20.1426 64.5811 20.8593 65.1 21.7943C65.5775 20.9632 66.2417 20.2776 67.0928 19.7374C67.9647 19.1765 69.0337 18.896 70.3 18.896Z"
      fill="#1A3842"
    />
    <path
      d="M86.4496 18.896C88.5254 18.896 90.103 19.4362 91.1825 20.5165C92.2826 21.5969 92.8327 23.1655 92.8327 25.2223V35.1637H89.3142V33.7301C88.7537 34.2703 88.1102 34.6962 87.3837 35.0079C86.6779 35.3195 85.8787 35.4753 84.9861 35.4753C83.3877 35.4753 82.1007 35.0702 81.1251 34.2599C80.1494 33.4496 79.6616 32.2966 79.6616 30.8007C79.6616 29.9489 79.8069 29.2321 80.0975 28.6504C80.4089 28.0479 80.8241 27.5596 81.343 27.1857C81.8828 26.7909 82.5055 26.5 83.2113 26.3131C83.9378 26.1261 84.7059 26.0118 85.5155 25.9703L89.3142 25.7521V25.2846C89.3142 24.2458 89.0859 23.4356 88.6292 22.8538C88.1933 22.2513 87.4771 21.9501 86.4807 21.9501C85.4843 21.9501 84.7578 22.2202 84.3011 22.7603C83.8444 23.3005 83.6161 23.9342 83.6161 24.6614L80.0975 24.5367C80.0975 23.8303 80.2428 23.1447 80.5335 22.4799C80.8241 21.7943 81.2392 21.1918 81.779 20.6724C82.3187 20.1322 82.9829 19.7063 83.7718 19.3946C84.5606 19.0622 85.4532 18.896 86.4496 18.896ZM86.0136 28.6815C85.1833 28.7231 84.4983 28.8997 83.9586 29.2113C83.4396 29.5022 83.1801 30.0112 83.1801 30.7384C83.1801 31.4032 83.3981 31.8707 83.834 32.1408C84.2907 32.4108 84.8719 32.5459 85.5777 32.5459C86.6987 32.5459 87.6017 32.2654 88.2867 31.7045C88.9925 31.1435 89.3453 30.2501 89.3453 29.0243V28.4634L86.0136 28.6815Z"
      fill="#1A3842"
    />
    <path
      d="M101.012 20.9841C101.385 20.4231 101.946 19.9349 102.693 19.5194C103.441 19.1038 104.375 18.8961 105.496 18.8961C106.409 18.8961 107.239 19.0519 107.987 19.3635C108.755 19.6544 109.409 20.0907 109.948 20.6724C110.509 21.2334 110.945 21.9294 111.256 22.7604C111.567 23.5707 111.723 24.4952 111.723 25.534V35.1637H108.205V26.0015C108.205 24.7965 107.883 23.8512 107.239 23.1656C106.617 22.4799 105.776 22.1371 104.717 22.1371C103.596 22.1371 102.693 22.5111 102.008 23.2591C101.344 23.9862 101.012 24.9108 101.012 26.0327V35.1637H97.5244V10.9492H101.012V20.9841Z"
      fill="#1A3842"
    />
    <path
      d="M121.48 18.896C123.556 18.896 125.133 19.4362 126.213 20.5165C127.313 21.5969 127.863 23.1655 127.863 25.2223V35.1637H124.344V33.7301C123.784 34.2703 123.141 34.6962 122.414 35.0079C121.708 35.3195 120.909 35.4753 120.016 35.4753C118.418 35.4753 117.131 35.0702 116.155 34.2599C115.18 33.4496 114.692 32.2966 114.692 30.8007C114.692 29.9489 114.837 29.2321 115.128 28.6504C115.439 28.0479 115.854 27.5596 116.373 27.1857C116.913 26.7909 117.536 26.5 118.242 26.3131C118.968 26.1261 119.736 26.0118 120.546 25.9703L124.344 25.7521V25.2846C124.344 24.2458 124.116 23.4356 123.659 22.8538C123.224 22.2513 122.507 21.9501 121.511 21.9501C120.515 21.9501 119.788 22.2202 119.331 22.7603C118.875 23.3005 118.646 23.9342 118.646 24.6614L115.128 24.5367C115.128 23.8303 115.273 23.1447 115.564 22.4799C115.854 21.7943 116.27 21.1918 116.809 20.6724C117.349 20.1322 118.013 19.7063 118.802 19.3946C119.591 19.0622 120.483 18.896 121.48 18.896ZM121.044 28.6815C120.214 28.7231 119.529 28.8997 118.989 29.2113C118.47 29.5022 118.21 30.0112 118.21 30.7384C118.21 31.4032 118.428 31.8707 118.864 32.1408C119.321 32.4108 119.902 32.5459 120.608 32.5459C121.729 32.5459 122.632 32.2654 123.317 31.7045C124.023 31.1435 124.376 30.2501 124.376 29.0243V28.4634L121.044 28.6815Z"
      fill="#1A3842"
    />
    <path
      d="M132.554 35.1637V10.9492H136.041V35.1637H132.554Z"
      fill="#1A3842"
    />
    <path
      d="M147.687 18.896C148.87 18.896 149.971 19.0934 150.988 19.4881C152.005 19.8621 152.877 20.4127 153.603 21.1398C154.351 21.8462 154.932 22.7188 155.347 23.7576C155.783 24.7756 156.001 25.9183 156.001 27.1857C156.001 28.453 155.783 29.5957 155.347 30.6137C154.932 31.6317 154.351 32.5043 153.603 33.2315C152.877 33.9379 152.005 34.4885 150.988 34.8832C149.971 35.2779 148.87 35.4753 147.687 35.4753C146.504 35.4753 145.404 35.2779 144.387 34.8832C143.369 34.4885 142.487 33.9379 141.74 33.2315C140.993 32.5043 140.401 31.6317 139.965 30.6137C139.55 29.5957 139.342 28.453 139.342 27.1857C139.342 25.9183 139.55 24.7756 139.965 23.7576C140.401 22.7188 140.993 21.8462 141.74 21.1398C142.487 20.4127 143.369 19.8621 144.387 19.4881C145.404 19.0934 146.504 18.896 147.687 18.896ZM147.687 21.8878C146.296 21.8878 145.144 22.3552 144.231 23.2901C143.338 24.2043 142.892 25.5028 142.892 27.1857C142.892 28.8477 143.338 30.1462 144.231 31.0812C145.144 31.9953 146.296 32.4524 147.687 32.4524C148.372 32.4524 149.005 32.3381 149.586 32.1096C150.168 31.8603 150.676 31.5175 151.112 31.0812C151.548 30.6241 151.88 30.0735 152.109 29.4295C152.358 28.7646 152.482 28.0167 152.482 27.1857C152.482 26.3546 152.358 25.6171 152.109 24.973C151.88 24.3082 151.548 23.7472 151.112 23.2901C150.676 22.8331 150.168 22.4903 149.586 22.2617C149.005 22.0124 148.372 21.8878 147.687 21.8878Z"
      fill="#1A3842"
    />
    <defs>
      <filter
        id="filter0_bd_22_26737"
        x="-146.873"
        y="-151.766"
        width="335.625"
        height="341.036"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="82" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_22_26737"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2" dy="3" />
        <feGaussianBlur stdDeviation="7.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_backgroundBlur_22_26737"
          result="effect2_dropShadow_22_26737"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_22_26737"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_22_26737"
        x1="9.76732"
        y1="39.6246"
        x2="39.6247"
        y2="9.69594"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3767F8" />
        <stop offset="0.481131" stopColor="#61D2F3" />
        <stop offset="1" stopColor="#10EAED" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_22_26737"
        x1="22.969"
        y1="12.8426"
        x2="4.69804"
        y2="32.3675"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2D23D4" />
        <stop offset="0.429794" stopColor="#2E48F3" />
        <stop offset="1" stopColor="#418CFD" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_22_26737"
        x1="20.9401"
        y1="12.2341"
        x2="17.1255"
        y2="24.1053"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4C0CCF" />
        <stop offset="1" stopColor="#344CEF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_22_26737"
        x1="33.4783"
        y1="15.9791"
        x2="21.7729"
        y2="29.0031"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#49D7E9" />
        <stop offset="0.456979" stopColor="#71CEF9" />
        <stop offset="1" stopColor="#6EB4FE" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_22_26737"
        x1="18.788"
        y1="26.5449"
        x2="24.891"
        y2="31.5622"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#588AFD" />
        <stop offset="0.471686" stopColor="#649EFF" />
        <stop offset="1" stopColor="#6DAFFF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_22_26737"
        x1="34.3466"
        y1="33.6343"
        x2="37.6969"
        y2="20.934"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C8FCC6" />
        <stop offset="0.497488" stopColor="#95F8D2" />
        <stop offset="1" stopColor="#5EF1DA" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_22_26737"
        x1="34.5309"
        y1="12.3569"
        x2="30.6356"
        y2="25.0103"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#15E6E8" />
        <stop offset="0.433113" stopColor="#36E8E5" />
        <stop offset="1" stopColor="#65E8E2" />
      </linearGradient>
    </defs>
  </svg>
);

export const PoweredByLogo = () => (
  <svg
    width="34"
    height="38"
    viewBox="0 0 34 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      opacity="0.14"
      cx="20.1521"
      cy="18.0169"
      r="10.0169"
      fill="url(#paint0_linear_371_8708)"
    />
    <path
      d="M27.2303 21.0924V14.7312C27.2303 13.7298 26.4328 12.918 25.4489 12.918C24.4651 12.918 23.6675 13.7298 23.6675 14.7312V19.0568C23.8357 18.894 24.0589 18.7589 24.2786 18.8353C24.3957 18.876 24.5002 18.9549 24.5479 19.094C24.6235 19.3141 24.5038 19.5465 24.3967 19.7526L23.9035 20.7023C23.8804 20.7469 23.8513 20.7882 23.8173 20.8248C23.7211 20.9284 23.6675 21.0655 23.6675 21.2079V21.5325C23.6675 22.2909 24.2715 22.9057 25.0166 22.9057H25.4489C26.4328 22.9057 27.2303 22.0938 27.2303 21.0924Z"
      fill="#9FF9E8"
    />
    <path
      d="M20.8053 21.1532V14.67C20.8053 13.67 19.9947 12.8594 18.9947 12.8594C17.9947 12.8594 17.1841 13.67 17.1841 14.67V19.07C17.355 18.9054 17.5833 18.7681 17.8072 18.8466C17.9272 18.8886 18.0338 18.9701 18.0811 19.1139C18.1533 19.3338 18.035 19.5637 17.928 19.7689L17.424 20.7347C17.4005 20.7799 17.3709 20.8217 17.3361 20.8589C17.2384 20.9636 17.1841 21.1015 17.1841 21.2446V21.5709C17.1841 22.3402 17.8077 22.9639 18.5771 22.9639H18.9947C19.9947 22.9639 20.8053 22.1532 20.8053 21.1532Z"
      fill="#849EFE"
    />
    <path
      d="M27.0525 16.9495C27.7667 16.2352 28.9203 16.2308 29.6291 16.9396C30.3379 17.6484 30.3335 18.802 29.6193 19.5162L26.6475 22.488C25.9333 23.2022 24.7797 23.2066 24.0709 22.4978C23.3621 21.789 23.3665 20.6354 24.0807 19.9212L27.0525 16.9495Z"
      fill="#10EAED"
    />
    <path
      d="M17.7336 13.407C18.4395 12.7011 19.5839 12.7011 20.2898 13.407C20.9957 14.1129 20.9957 15.2573 20.2898 15.9632L13.8341 22.4189C13.1282 23.1248 11.9838 23.1248 11.2779 22.4189C10.572 21.713 10.572 20.5686 11.2779 19.8627L17.7336 13.407Z"
      fill="url(#paint1_linear_371_8708)"
    />
    <g filter="url(#filter0_bd_371_8708)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5351 13.5768C17.3144 13.8769 17.1841 14.2474 17.1841 14.6484V19.0501C17.1875 19.0468 17.1909 19.0436 17.1943 19.0404L20.2826 15.9512C20.5939 15.6398 20.7682 15.2432 20.8053 14.8365V14.6484C20.8053 14.448 20.7728 14.2553 20.7127 14.0752C20.6259 13.8248 20.4825 13.5898 20.2826 13.3898C19.5755 12.6826 18.4291 12.6826 17.722 13.3898L17.5351 13.5768Z"
        fill="url(#paint2_linear_371_8708)"
      />
    </g>
    <path
      d="M24.1052 13.4744C24.831 12.7486 26.0079 12.7486 26.7337 13.4744C27.4596 14.2003 27.4596 15.3771 26.7337 16.103L20.2449 22.5918C19.519 23.3176 18.3422 23.3176 17.6163 22.5918C16.8905 21.8659 16.8905 20.6891 17.6163 19.9632L24.1052 13.4744Z"
      fill="url(#paint3_linear_371_8708)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.4346 22.4111C20.6674 22.0995 20.8052 21.7127 20.8052 21.2938V16.7747C20.8017 16.778 20.7982 16.7814 20.7947 16.7847L17.6067 19.9613C17.2854 20.2815 17.1055 20.6893 17.0671 21.1076V21.2938C17.0671 21.552 17.1194 21.7979 17.2141 22.0216C17.305 22.2298 17.4358 22.4249 17.6067 22.5951C18.3366 23.3225 19.52 23.3225 20.2499 22.5951L20.4346 22.4111Z"
      fill="url(#paint4_linear_371_8708)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.8671 22.2998C27.0952 21.9967 27.23 21.6223 27.23 21.2171V16.7743C27.2265 16.7776 27.2229 16.7809 27.2194 16.7842L24.0315 19.9025C23.7102 20.2168 23.5303 20.6171 23.4919 21.0277V21.2171C23.4919 21.4227 23.5266 21.6203 23.5906 21.8048C23.6806 22.0543 23.8275 22.2884 24.0315 22.488C24.7614 23.2019 25.9448 23.2019 26.6747 22.488L26.8671 22.2998Z"
      fill="url(#paint5_linear_371_8708)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.96 13.6545C23.7391 13.958 23.6089 14.3317 23.6089 14.7358V19.2255C23.6123 19.2222 23.6158 19.2189 23.6193 19.2156L26.7574 16.0681C27.0737 15.7509 27.2508 15.3468 27.2886 14.9324V14.7358C27.2886 14.5615 27.2643 14.393 27.2191 14.2332C27.1346 13.9496 26.9807 13.6824 26.7574 13.4584C26.0389 12.7378 24.874 12.7378 24.1555 13.4584L23.96 13.6545Z"
      fill="url(#paint6_linear_371_8708)"
    />
    <defs>
      <filter
        id="filter0_bd_371_8708"
        x="-146.816"
        y="-151.141"
        width="331.621"
        height="334.191"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="82" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_371_8708"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2" dy="3" />
        <feGaussianBlur stdDeviation="7.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_backgroundBlur_371_8708"
          result="effect2_dropShadow_371_8708"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_371_8708"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_371_8708"
        x1="13.6885"
        y1="25.8679"
        x2="27.8678"
        y2="11.6548"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3767F8" />
        <stop offset="0.481131" stopColor="#61D2F3" />
        <stop offset="1" stopColor="#10EAED" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_371_8708"
        x1="19.9579"
        y1="13.1495"
        x2="11.2811"
        y2="22.4218"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2D23D4" />
        <stop offset="0.429794" stopColor="#2E48F3" />
        <stop offset="1" stopColor="#418CFD" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_371_8708"
        x1="18.9947"
        y1="12.8594"
        x2="17.1832"
        y2="18.497"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4C0CCF" />
        <stop offset="1" stopColor="#344CEF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_371_8708"
        x1="24.9486"
        y1="14.6395"
        x2="19.3897"
        y2="20.8246"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#49D7E9" />
        <stop offset="0.456979" stopColor="#71CEF9" />
        <stop offset="1" stopColor="#6EB4FE" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_371_8708"
        x1="17.9724"
        y1="19.6571"
        x2="20.8708"
        y2="22.0398"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#588AFD" />
        <stop offset="0.471686" stopColor="#649EFF" />
        <stop offset="1" stopColor="#6DAFFF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_371_8708"
        x1="25.3609"
        y1="23.0234"
        x2="26.952"
        y2="16.9921"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C8FCC6" />
        <stop offset="0.497488" stopColor="#95F8D2" />
        <stop offset="1" stopColor="#5EF1DA" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_371_8708"
        x1="25.4487"
        y1="12.918"
        x2="23.5989"
        y2="18.927"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#15E6E8" />
        <stop offset="0.433113" stopColor="#36E8E5" />
        <stop offset="1" stopColor="#65E8E2" />
      </linearGradient>
    </defs>
  </svg>
);

export const TermsLogo = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2.68213C12.2058 2.68213 12.4153 2.71907 12.6279 2.79541V2.79639L18.3203 4.92139C18.6201 5.04062 18.872 5.22367 19.0762 5.47021L19.1611 5.57959C19.3789 5.8817 19.4873 6.22057 19.4873 6.59619V11.1001C19.4873 13.171 18.9403 15.1095 17.8457 16.9155L17.6191 17.2749C16.4515 19.063 14.9057 20.3417 12.9814 21.1118L12.5918 21.2593C12.4989 21.2923 12.4029 21.317 12.3037 21.3335C12.2044 21.35 12.1032 21.3589 12 21.3589C11.9484 21.3589 11.8973 21.3562 11.8467 21.3521L11.6963 21.3335C11.6467 21.3252 11.5978 21.3156 11.5498 21.3032L11.4082 21.2593C9.4335 20.557 7.83713 19.3458 6.61914 17.6255L6.38086 17.2749C5.13534 15.3672 4.5127 13.3091 4.5127 11.1001V6.59619L4.51758 6.45752C4.53796 6.18254 4.61973 5.92841 4.7627 5.69482L4.83887 5.57959C5.02941 5.31486 5.26766 5.11348 5.55371 4.97607L5.67969 4.92139L11.3721 2.79639L11.3711 2.79541C11.584 2.71887 11.7939 2.68213 12 2.68213ZM12 4.14111C11.9801 4.14111 11.9608 4.14265 11.9424 4.146L11.8896 4.16162L6.19727 6.28662C6.14779 6.30643 6.10633 6.33371 6.07324 6.36865L6.04297 6.40674C6.00621 6.46015 5.98735 6.52007 5.9873 6.58643V11.1001C5.9873 12.9931 6.48605 14.725 7.4834 16.2954L7.68945 16.6069C8.82414 18.2589 10.26 19.3607 11.9961 19.9116L11.9951 19.9146L12.0039 19.9116C13.6315 19.3951 14.9948 18.3948 16.0938 16.9106L16.3105 16.6069C17.4452 14.9549 18.0127 13.1191 18.0127 11.1001V6.58643C18.0127 6.5533 18.0082 6.52164 17.999 6.4917L17.957 6.40674C17.9386 6.37987 17.9165 6.35646 17.8906 6.33643L17.8027 6.28662L12.1104 4.16162C12.0767 4.14814 12.0399 4.14111 12 4.14111ZM15.1924 9.13721C15.3407 9.13723 15.4765 9.18013 15.5996 9.26611L15.7178 9.3667C15.8706 9.51966 15.9455 9.69629 15.9424 9.89697L15.9268 10.0425C15.9073 10.1363 15.8697 10.2231 15.8145 10.3032L15.7178 10.4185L11.5742 14.563C11.3956 14.7414 11.1876 14.8295 10.9502 14.8296C10.7425 14.8296 10.5572 14.762 10.3945 14.6255L10.3262 14.563L8.3125 12.5337C8.1597 12.3807 8.08408 12.2057 8.08398 12.0083C8.08398 11.8601 8.12618 11.7241 8.21191 11.6011L8.3125 11.4819C8.42722 11.3673 8.55382 11.2968 8.69238 11.27L8.83496 11.2583C8.98182 11.2606 9.11525 11.3024 9.23438 11.3853L9.34863 11.4819L10.9502 13.0835L14.667 9.3667C14.82 9.2138 14.995 9.13721 15.1924 9.13721Z"
      fill="#6B7280"
      stroke="#6B7280"
      stroke-width="0.025"
    />
  </svg>
);

export const PrivacyLogo = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2.68213C12.2058 2.68213 12.4153 2.71907 12.6279 2.79541V2.79639L18.3203 4.92139C18.6215 5.04019 18.8744 5.22232 19.0781 5.46826L19.1621 5.57764C19.379 5.87941 19.4873 6.21903 19.4873 6.59619V11.1001C19.4873 13.171 18.9403 15.1095 17.8457 16.9155L17.6191 17.2749C16.4515 19.063 14.9057 20.3417 12.9814 21.1118L12.5918 21.2593C12.4989 21.2923 12.4029 21.317 12.3037 21.3335C12.2044 21.35 12.1032 21.3589 12 21.3589C11.9484 21.3589 11.8973 21.3562 11.8467 21.3521L11.6963 21.3335C11.6467 21.3252 11.5978 21.3156 11.5498 21.3032L11.4082 21.2593C9.4335 20.557 7.83713 19.3458 6.61914 17.6255L6.38086 17.2749C5.13534 15.3672 4.5127 13.3091 4.5127 11.1001V6.59619L4.51758 6.45654C4.53794 6.18074 4.61935 5.92626 4.76172 5.69287L4.83789 5.57764C5.02775 5.3135 5.26638 5.113 5.55371 4.97607L5.67969 4.92139L11.3721 2.79639L11.3711 2.79541C11.584 2.71887 11.7939 2.68213 12 2.68213ZM12 4.14111C11.9801 4.14111 11.9608 4.14265 11.9424 4.146L11.8896 4.16162L6.19727 6.28662C6.14779 6.30643 6.10633 6.33371 6.07324 6.36865L6.04297 6.40674C6.00621 6.46015 5.98735 6.52007 5.9873 6.58643V11.1001C5.9873 12.9931 6.48605 14.725 7.4834 16.2954L7.68945 16.6069C8.82414 18.2589 10.26 19.3607 11.9961 19.9116L11.9951 19.9146L12.0039 19.9116C13.6315 19.3951 14.9948 18.3948 16.0938 16.9106L16.3105 16.6069C17.4452 14.9549 18.0127 13.1191 18.0127 11.1001V6.58643C18.0127 6.5533 18.0082 6.52164 17.999 6.4917L17.957 6.40674C17.9386 6.37987 17.9165 6.35646 17.8906 6.33643L17.8027 6.28662L12.1104 4.16162C12.0767 4.14814 12.0399 4.14111 12 4.14111ZM12.0098 8.18604C12.4656 8.18609 12.8611 8.3247 13.1963 8.60303L13.3359 8.73096C13.6996 9.09458 13.8818 9.53704 13.8818 10.0581V11.0708H13.9805C14.2017 11.0708 14.3916 11.1356 14.5498 11.2661L14.6162 11.3267C14.7867 11.4974 14.872 11.7088 14.8721 11.9614V14.9233C14.872 15.1448 14.8066 15.3344 14.6758 15.4927L14.6162 15.5581C14.4455 15.729 14.2335 15.8149 13.9805 15.8149H10.0195C9.79824 15.8149 9.60844 15.7494 9.4502 15.6187L9.38379 15.5581C9.2133 15.3875 9.12796 15.1762 9.12793 14.9233V11.9614C9.12798 11.7401 9.19339 11.5505 9.32422 11.3921L9.38379 11.3267C9.55449 11.156 9.76651 11.0708 10.0195 11.0708H10.1377V10.0581C10.1377 9.60232 10.2765 9.20683 10.5547 8.87158L10.6826 8.73096C11.0462 8.3672 11.4887 8.18604 12.0098 8.18604ZM12.0098 9.04541C11.7592 9.04541 11.5433 9.11957 11.3633 9.26807L11.2881 9.33643C11.094 9.53055 10.9971 9.77162 10.9971 10.0581V11.0708H13.0225V10.0581C13.0225 9.77162 12.9246 9.53055 12.7305 9.33643C12.5364 9.14254 12.296 9.04547 12.0098 9.04541Z"
      fill="#6B7280"
      stroke="#6B7280"
      stroke-width="0.025"
    />
  </svg>
);

export const MahaloCareLogo = () => (
  <svg
    width="156"
    height="43"
    viewBox="0 0 156 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.14"
      d="M43.0221 21.3663C43.0221 33.1666 33.456 42.7326 21.6557 42.7326C9.85546 42.7326 0.289429 33.1666 0.289429 21.3663C0.289429 9.56603 9.85546 0 21.6557 0C33.456 0 43.0221 9.56603 43.0221 21.3663Z"
      fill="url(#paint0_linear_97_39825)"
    />
    <path
      d="M36.7564 27.9286V14.3599C36.7564 12.2238 35.0552 10.4922 32.9566 10.4922C30.858 10.4922 29.1567 12.2238 29.1567 14.3599V23.5865C29.5156 23.2394 29.9917 22.9511 30.4602 23.114C30.7101 23.2009 30.9329 23.3693 31.0348 23.6659C31.196 24.1355 30.9406 24.631 30.7123 25.0707L29.6603 27.0965C29.6108 27.1917 29.5489 27.2796 29.4762 27.3578C29.2711 27.5787 29.1567 27.8711 29.1567 28.175V28.8673C29.1567 30.4849 30.4451 31.7963 32.0344 31.7963H32.9566C35.0552 31.7963 36.7564 30.0647 36.7564 27.9286Z"
      fill="#C3B8FF"
    />
    <path
      d="M23.0518 28.0583V14.2293C23.0518 12.0963 21.3227 10.3672 19.1897 10.3672C17.0567 10.3672 15.3275 12.0963 15.3275 14.2293V23.6147C15.6922 23.2636 16.179 22.9708 16.6567 23.1381C16.9127 23.2278 17.1401 23.4017 17.2409 23.7084C17.3949 24.1774 17.1426 24.6677 16.9142 25.1054L15.8393 27.1656C15.7891 27.262 15.726 27.3511 15.6518 27.4306C15.4434 27.6538 15.3275 27.9479 15.3275 28.2533V28.9492C15.3275 30.5902 16.6578 31.9205 18.2988 31.9205H19.1897C21.3227 31.9205 23.0518 30.1913 23.0518 28.0583Z"
      fill="#C3B8FF"
    />
    <path
      d="M36.3747 19.0866C37.8982 17.5631 40.3588 17.5538 41.8707 19.0656V19.0656C43.3826 20.5775 43.3732 23.0382 41.8497 24.5616L35.5109 30.9005C33.9874 32.4239 31.5268 32.4333 30.0149 30.9214V30.9214C28.503 29.4095 28.5124 26.9489 30.0359 25.4254L36.3747 19.0866Z"
      fill="url(#paint1_linear_97_39825)"
    />
    <path
      d="M16.4966 11.5309C18.0022 10.0253 20.4433 10.0253 21.949 11.5309V11.5309C23.4546 13.0366 23.4546 15.4777 21.949 16.9833L8.17871 30.7536C6.67306 32.2593 4.23192 32.2593 2.72627 30.7536V30.7536C1.22062 29.248 1.22062 26.8068 2.72627 25.3012L16.4966 11.5309Z"
      fill="url(#paint2_linear_97_39825)"
    />
    <path
      d="M30.0883 11.6706C31.6366 10.1223 34.1468 10.1223 35.6951 11.6706V11.6706C37.2434 13.2188 37.2434 15.7291 35.6951 17.2773L21.8542 31.1182C20.306 32.6665 17.7957 32.6665 16.2475 31.1182V31.1182C14.6992 29.57 14.6992 27.0597 16.2475 25.5115L30.0883 11.6706Z"
      fill="url(#paint3_linear_97_39825)"
    />
    <path
      d="M69.1872 9.85938C70.0914 9.85938 70.9115 10.0172 71.6475 10.3329C72.4045 10.6486 73.0458 11.1011 73.5715 11.6904C74.0972 12.2796 74.5072 12.9847 74.8016 13.8055C75.096 14.6052 75.2432 15.5102 75.2432 16.5203V26.3382H71.679V17.057C71.679 15.8364 71.3846 14.8788 70.7958 14.1843C70.2071 13.4898 69.3765 13.1425 68.3041 13.1425C67.2947 13.1425 66.4852 13.4582 65.8754 14.0896C65.2656 14.7209 64.9081 15.5207 64.8029 16.4888V16.5835V26.3382H61.2388V17.057C61.2388 15.8364 60.9338 14.8788 60.324 14.1843C59.7353 13.4898 58.9573 13.1425 57.99 13.1425C56.8545 13.1425 55.9503 13.5213 55.2774 14.279C54.6255 15.0156 54.2996 15.9521 54.2996 17.0886V26.3382H50.767V10.1435H54.1104V12.2902C54.5309 11.5746 55.1092 10.9958 55.8452 10.5539C56.6021 10.0909 57.5799 9.85938 58.7785 9.85938C59.914 9.85938 60.9233 10.1119 61.8065 10.617C62.6897 11.1221 63.3941 11.8482 63.9198 12.7953C64.4034 11.9534 65.0763 11.2589 65.9384 10.7117C66.8216 10.1435 67.9045 9.85938 69.1872 9.85938Z"
      fill="#212121"
    />
    <path
      d="M85.5473 9.85938C87.6501 9.85938 89.2482 10.4066 90.3416 11.5009C91.4561 12.5953 92.0133 14.1843 92.0133 16.2678V26.3382H88.4491V24.886C87.8814 25.4332 87.2295 25.8647 86.4936 26.1803C85.7786 26.496 84.969 26.6539 84.0649 26.6539C82.4457 26.6539 81.142 26.2435 80.1537 25.4227C79.1654 24.6019 78.6713 23.4339 78.6713 21.9186C78.6713 21.0557 78.8185 20.3296 79.1128 19.7403C79.4283 19.13 79.8488 18.6354 80.3745 18.2566C80.9212 17.8568 81.5521 17.5621 82.267 17.3727C83.003 17.1833 83.781 17.0675 84.6011 17.0254L88.4491 16.8045V16.3309C88.4491 15.2787 88.2178 14.4579 87.7552 13.8686C87.3136 13.2583 86.5882 12.9531 85.5789 12.9531C84.5695 12.9531 83.8336 13.2267 83.3709 13.7739C82.9083 14.3211 82.677 14.963 82.677 15.6996L79.1128 15.5733C79.1128 14.8577 79.26 14.1632 79.5544 13.4898C79.8488 12.7953 80.2694 12.1849 80.8161 11.6588C81.3628 11.1116 82.0357 10.6802 82.8347 10.3645C83.6338 10.0277 84.538 9.85938 85.5473 9.85938ZM85.1057 19.7719C84.2646 19.814 83.5707 19.9929 83.024 20.3086C82.4983 20.6032 82.2355 21.1188 82.2355 21.8554C82.2355 22.5289 82.4562 23.0024 82.8978 23.276C83.3604 23.5496 83.9492 23.6864 84.6641 23.6864C85.7996 23.6864 86.7143 23.4023 87.4083 22.8341C88.1232 22.2658 88.4807 21.3609 88.4807 20.1192V19.5509L85.1057 19.7719Z"
      fill="#212121"
    />
    <path
      d="M100.297 11.9776C100.675 11.4094 101.243 10.9148 102 10.4939C102.757 10.073 103.703 9.8625 104.839 9.8625C105.764 9.8625 106.605 10.0203 107.362 10.336C108.14 10.6307 108.802 11.0726 109.349 11.6619C109.917 12.2301 110.358 12.9352 110.674 13.777C110.989 14.5978 111.147 15.5343 111.147 16.5866V26.3413H107.583V17.0601C107.583 15.8395 107.257 14.8819 106.605 14.1874C105.974 13.4929 105.122 13.1456 104.05 13.1456C102.915 13.1456 102 13.5245 101.306 14.2821C100.633 15.0187 100.297 15.9552 100.297 17.0917V26.3413H96.7639V1.8125H100.297V11.9776Z"
      fill="#212121"
    />
    <path
      d="M121.029 9.85938C123.132 9.85938 124.73 10.4066 125.823 11.5009C126.938 12.5953 127.495 14.1843 127.495 16.2678V26.3382H123.931V24.886C123.363 25.4332 122.711 25.8647 121.975 26.1803C121.26 26.496 120.451 26.6539 119.547 26.6539C117.928 26.6539 116.624 26.2435 115.636 25.4227C114.647 24.6019 114.153 23.4339 114.153 21.9186C114.153 21.0557 114.3 20.3296 114.595 19.7403C114.91 19.13 115.331 18.6354 115.856 18.2566C116.403 17.8568 117.034 17.5621 117.749 17.3727C118.485 17.1833 119.263 17.0675 120.083 17.0254L123.931 16.8045V16.3309C123.931 15.2787 123.7 14.4579 123.237 13.8686C122.795 13.2583 122.07 12.9531 121.061 12.9531C120.051 12.9531 119.315 13.2267 118.853 13.7739C118.39 14.3211 118.159 14.963 118.159 15.6996L114.595 15.5733C114.595 14.8577 114.742 14.1632 115.036 13.4898C115.331 12.7953 115.751 12.1849 116.298 11.6588C116.845 11.1116 117.518 10.6802 118.317 10.3645C119.116 10.0277 120.02 9.85938 121.029 9.85938ZM120.588 19.7719C119.746 19.814 119.053 19.9929 118.506 20.3086C117.98 20.6032 117.717 21.1188 117.717 21.8554C117.717 22.5289 117.938 23.0024 118.38 23.276C118.842 23.5496 119.431 23.6864 120.146 23.6864C121.281 23.6864 122.196 23.4023 122.89 22.8341C123.605 22.2658 123.962 21.3609 123.962 20.1192V19.5509L120.588 19.7719Z"
      fill="#212121"
    />
    <path d="M132.251 26.3413V1.8125H135.784V26.3413H132.251Z" fill="#212121" />
    <path
      d="M147.578 9.85938C148.777 9.85938 149.891 10.0593 150.922 10.4592C151.952 10.838 152.835 11.3957 153.571 12.1323C154.328 12.8479 154.917 13.7318 155.338 14.7841C155.779 15.8153 156 16.9728 156 18.2566C156 19.5404 155.779 20.6979 155.338 21.7292C154.917 22.7604 154.328 23.6443 153.571 24.3809C152.835 25.0965 151.952 25.6542 150.922 26.0541C149.891 26.4539 148.777 26.6539 147.578 26.6539C146.38 26.6539 145.265 26.4539 144.235 26.0541C143.205 25.6542 142.311 25.0965 141.554 24.3809C140.797 23.6443 140.198 22.7604 139.756 21.7292C139.336 20.6979 139.125 19.5404 139.125 18.2566C139.125 16.9728 139.336 15.8153 139.756 14.7841C140.198 13.7318 140.797 12.8479 141.554 12.1323C142.311 11.3957 143.205 10.838 144.235 10.4592C145.265 10.0593 146.38 9.85938 147.578 9.85938ZM147.578 12.89C146.17 12.89 145.002 13.3635 144.077 14.3105C143.173 15.2366 142.721 16.5519 142.721 18.2566C142.721 19.9403 143.173 21.2556 144.077 22.2027C145.002 23.1287 146.17 23.5917 147.578 23.5917C148.272 23.5917 148.914 23.476 149.502 23.2445C150.091 22.9919 150.606 22.6447 151.048 22.2027C151.49 21.7397 151.826 21.182 152.057 20.5296C152.31 19.8561 152.436 19.0985 152.436 18.2566C152.436 17.4148 152.31 16.6677 152.057 16.0153C151.826 15.3418 151.49 14.7736 151.048 14.3105C150.606 13.8475 150.091 13.5003 149.502 13.2688C148.914 13.0162 148.272 12.89 147.578 12.89Z"
      fill="#212121"
    />
    <path
      d="M150.412 38.0749V30.8359H155.207V32.0851H151.927V33.8309H155.022V34.9947H151.927V36.8258H155.207V38.0749H150.412Z"
      fill="url(#paint4_linear_97_39825)"
    />
    <path
      d="M138.86 38.0749V30.8359H141.875C142.424 30.8359 142.89 30.9296 143.275 31.1169C143.663 31.3008 143.957 31.565 144.158 31.9095C144.362 32.254 144.464 32.6637 144.464 33.1386V33.1486C144.464 33.6135 144.348 34.0315 144.118 34.4027C143.89 34.7706 143.569 35.0365 143.154 35.2004L144.679 38.0749H142.964L141.614 35.4261C141.604 35.4261 141.592 35.4261 141.579 35.4261C141.566 35.4261 141.554 35.4261 141.544 35.4261H140.375V38.0749H138.86ZM140.375 34.3225H141.71C142.087 34.3225 142.382 34.2221 142.592 34.0215C142.807 33.8175 142.914 33.5365 142.914 33.1787V33.1687C142.914 32.8175 142.805 32.5382 142.587 32.3309C142.37 32.1235 142.071 32.0199 141.689 32.0199H140.375V34.3225Z"
      fill="url(#paint5_linear_97_39825)"
    />
    <path
      d="M126.401 38.0749L128.914 30.8359H130.203V32.2807H129.762L127.991 38.0749H126.401ZM127.745 36.3191L128.116 35.1853H131.462L131.834 36.3191H127.745ZM131.618 38.0749L129.852 32.2807V30.8359H130.695L133.213 38.0749H131.618Z"
      fill="url(#paint6_linear_97_39825)"
    />
    <path
      d="M118.19 38.2586C117.491 38.2586 116.888 38.1048 116.379 37.7971C115.871 37.4894 115.48 37.0513 115.205 36.4828C114.931 35.9142 114.794 35.2386 114.794 34.456V34.446C114.794 33.6634 114.931 32.9878 115.205 32.4193C115.48 31.8508 115.869 31.4143 116.374 31.11C116.883 30.8023 117.488 30.6484 118.19 30.6484C118.762 30.6484 119.275 30.7605 119.73 30.9846C120.188 31.2086 120.558 31.518 120.839 31.9126C121.12 32.3073 121.284 32.7588 121.331 33.2671V33.3323H119.861L119.856 33.2972C119.806 33.0263 119.704 32.7889 119.55 32.5848C119.396 32.3775 119.202 32.217 118.968 32.1033C118.737 31.9895 118.478 31.9327 118.19 31.9327C117.812 31.9327 117.485 32.0347 117.207 32.2387C116.929 32.4394 116.715 32.7287 116.565 33.1066C116.418 33.4811 116.344 33.9276 116.344 34.446V34.456C116.344 34.9711 116.418 35.4176 116.565 35.7955C116.715 36.1734 116.929 36.4644 117.207 36.6684C117.485 36.8724 117.814 36.9744 118.195 36.9744C118.486 36.9744 118.745 36.9225 118.973 36.8189C119.204 36.7118 119.394 36.563 119.545 36.3724C119.699 36.1784 119.801 35.9527 119.851 35.6951L119.861 35.65H121.336V35.7102C121.282 36.2152 121.117 36.6583 120.839 37.0396C120.561 37.4209 120.197 37.7202 119.745 37.9376C119.294 38.1516 118.775 38.2586 118.19 38.2586Z"
      fill="url(#paint7_linear_97_39825)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_97_39825"
        x1="7.8687"
        y1="38.1129"
        x2="38.1136"
        y2="7.79582"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F745D1" />
        <stop offset="0.481131" stopColor="#B405EC" />
        <stop offset="1" stopColor="#2768C1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_97_39825"
        x1="41.1905"
        y1="18.4833"
        x2="29.6165"
        y2="30.5389"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F84AC9" />
        <stop offset="0.499374" stopColor="#F030EA" />
        <stop offset="1" stopColor="#BF2FEB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_97_39825"
        x1="21.2411"
        y1="10.9816"
        x2="2.73298"
        y2="30.7599"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1500D9" />
        <stop offset="0.499374" stopColor="#294FCB" />
        <stop offset="1" stopColor="#2669BF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_97_39825"
        x1="34.7514"
        y1="11.7804"
        x2="16.87"
        y2="30.4646"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B800EC" />
        <stop offset="0.456979" stopColor="#8F2EE6" />
        <stop offset="1" stopColor="#472CDA" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_97_39825"
        x1="114.224"
        y1="34.4488"
        x2="155.925"
        y2="34.4488"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2765C2" />
        <stop offset="1" stopColor="#190DD7" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_97_39825"
        x1="114.224"
        y1="34.4488"
        x2="155.925"
        y2="34.4488"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2765C2" />
        <stop offset="1" stopColor="#190DD7" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_97_39825"
        x1="114.224"
        y1="34.4488"
        x2="155.925"
        y2="34.4488"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2765C2" />
        <stop offset="1" stopColor="#190DD7" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_97_39825"
        x1="114.224"
        y1="34.4469"
        x2="155.925"
        y2="34.4469"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2765C2" />
        <stop offset="1" stopColor="#190DD7" />
      </linearGradient>
    </defs>
  </svg>
);

export const QueryIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.228 9C8.777 7.835 10.258 7 12 7C14.21 7 16 8.343 16 10C16 11.4 14.722 12.575 12.994 12.907C12.452 13.011 12 13.447 12 14M12 17H12.01M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="svgicon stroke"
    />
  </svg>
);

export const QueryIconActive = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442Z"
      className="svgicon-primary fill"
    />
    <path
      d="M8.228 9C8.777 7.835 10.258 7 12 7C14.21 7 16 8.343 16 10C16 11.4 14.722 12.575 12.994 12.907C12.452 13.011 12 13.447 12 14M12 17H12.01"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="svgicon-primary fill"
    />
  </svg>
);

export const AdminIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <path
      d="M19.4854 18.864L19.4927 18.853L19.4814 18.8463C19.1137 18.629 18.7211 18.4619 18.3034 18.345C17.8856 18.228 17.4511 18.1695 17 18.1695C16.5489 18.1695 16.1144 18.228 15.6966 18.345C15.2789 18.4619 14.8863 18.629 14.5186 18.8463L14.5073 18.853L14.5146 18.864C14.7824 19.2657 15.1339 19.5878 15.5689 19.8305C16.0042 20.0732 16.4813 20.1945 17 20.1945C17.5187 20.1945 17.9958 20.0732 18.4311 19.8305C18.8661 19.5878 19.2176 19.2657 19.4854 18.864ZM11.5296 22.0454L11.5297 22.0454L11.5287 22.0451C9.34823 21.3793 7.55047 20.0311 6.13526 17.9999C4.72003 15.9686 4.0125 13.7294 4.0125 11.282V6.55703C4.0125 6.14297 4.13252 5.77054 4.37262 5.43937C4.61286 5.108 4.9234 4.86784 5.30447 4.71871C5.3045 4.71869 5.30453 4.71868 5.30456 4.71867L11.3042 2.4688C11.3042 2.46879 11.3043 2.46878 11.3043 2.46877C11.5363 2.38591 11.7682 2.34453 12 2.34453C12.2318 2.34453 12.4637 2.38591 12.6957 2.46877C12.6957 2.46878 12.6958 2.46879 12.6958 2.4688L18.6954 4.71867C18.6955 4.71868 18.6955 4.71869 18.6955 4.71871C19.0766 4.86784 19.3871 5.108 19.6274 5.43937C19.8675 5.77054 19.9875 6.14297 19.9875 6.55703V10.8382C19.676 10.7076 19.3564 10.5891 19.0289 10.4826C18.6982 10.3752 18.3595 10.2964 18.0125 10.2462V6.58203V6.57337L18.0044 6.57033L12.0044 4.32033L12.0058 4.3165L11.9956 4.32033L5.99561 6.57033L5.9875 6.57337V6.58203V11.282C5.9875 12.0665 6.09182 12.8509 6.30042 13.6352C6.50899 14.4195 6.801 15.1662 7.17645 15.8754C7.55192 16.5846 8.00666 17.2396 8.54066 17.8403C9.07372 18.44 9.66504 18.9401 10.3146 19.3403C10.498 19.8729 10.7313 20.3723 11.0143 20.8385C11.2929 21.2974 11.6198 21.7161 11.9949 22.0945H11.7625C11.6894 22.0945 11.6118 22.0783 11.5296 22.0454ZM17 17.1945C17.4199 17.1945 17.7773 17.0474 18.0713 16.7534C18.3654 16.4593 18.5125 16.102 18.5125 15.682C18.5125 15.2621 18.3654 14.9047 18.0713 14.6107C17.7773 14.3167 17.4199 14.1695 17 14.1695C16.5801 14.1695 16.2227 14.3167 15.9287 14.6107C15.6346 14.9047 15.4875 15.2621 15.4875 15.682C15.4875 16.102 15.6346 16.4593 15.9287 16.7534C16.2227 17.0474 16.5801 17.1945 17 17.1945ZM17 22.1695C15.62 22.1695 14.444 21.6833 13.4713 20.7107C12.4987 19.738 12.0125 18.5621 12.0125 17.182C12.0125 15.802 12.4987 14.626 13.4713 13.6534C14.444 12.6807 15.62 12.1945 17 12.1945C18.38 12.1945 19.556 12.6807 20.5287 13.6534C21.5013 14.626 21.9875 15.802 21.9875 17.182C21.9875 18.5621 21.5013 19.738 20.5287 20.7107C19.556 21.6833 18.38 22.1695 17 22.1695Z"
      strokeWidth="0.025"
      className="svgicon fill stroke"
    />
  </svg>
);

export const AdminIconActive = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M17 16.9984C17.4167 16.9984 17.7708 16.8526 18.0625 16.5609C18.3542 16.2693 18.5 15.9151 18.5 15.4984C18.5 15.0818 18.3542 14.7276 18.0625 14.4359C17.7708 14.1443 17.4167 13.9984 17 13.9984C16.5833 13.9984 16.2292 14.1443 15.9375 14.4359C15.6458 14.7276 15.5 15.0818 15.5 15.4984C15.5 15.9151 15.6458 16.2693 15.9375 16.5609C16.2292 16.8526 16.5833 16.9984 17 16.9984ZM17 19.9984C17.5167 19.9984 17.9917 19.8776 18.425 19.6359C18.8583 19.3943 19.2083 19.0734 19.475 18.6734C19.1083 18.4568 18.7167 18.2901 18.3 18.1734C17.8833 18.0568 17.45 17.9984 17 17.9984C16.55 17.9984 16.1167 18.0568 15.7 18.1734C15.2833 18.2901 14.8917 18.4568 14.525 18.6734C14.7917 19.0734 15.1417 19.3943 15.575 19.6359C16.0083 19.8776 16.4833 19.9984 17 19.9984ZM17 21.9984C15.6167 21.9984 14.4375 21.5109 13.4625 20.5359C12.4875 19.5609 12 18.3818 12 16.9984C12 15.6151 12.4875 14.4359 13.4625 13.4609C14.4375 12.4859 15.6167 11.9984 17 11.9984C18.3833 11.9984 19.5625 12.4859 20.5375 13.4609C21.5125 14.4359 22 15.6151 22 16.9984C22 18.3818 21.5125 19.5609 20.5375 20.5359C19.5625 21.5109 18.3833 21.9984 17 21.9984ZM12 21.9234H11.7625C11.6875 21.9234 11.6083 21.9068 11.525 21.8734C9.34167 21.2068 7.54167 19.8568 6.125 17.8234C4.70833 15.7901 4 13.5484 4 11.0984V6.37344C4 5.95677 4.12083 5.58177 4.3625 5.24844C4.60417 4.9151 4.91667 4.67344 5.3 4.52344L11.3 2.27344C11.5333 2.1901 11.7667 2.14844 12 2.14844C12.2333 2.14844 12.4667 2.1901 12.7 2.27344L18.7 4.52344C19.0833 4.67344 19.3958 4.9151 19.6375 5.24844C19.8792 5.58177 20 5.95677 20 6.37344V10.6734C19.5167 10.4568 19.0292 10.2901 18.5375 10.1734C18.0458 10.0568 17.5333 9.99844 17 9.99844C15.0667 9.99844 13.4167 10.6818 12.05 12.0484C10.6833 13.4151 10 15.0651 10 16.9984C10 17.9484 10.1667 18.8359 10.5 19.6609C10.8333 20.4859 11.3417 21.2401 12.025 21.9234H12Z"
      className="svgicon-primary fill"
    />
  </svg>
);

export const HomeIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  // className="side-bar-icon"
  >
    <path
      d="M5.5 19.1836V19.6836H6H9H9.5V19.1836V13.6836H14.5V19.1836V19.6836H15H18H18.5V19.1836V10.1836V9.93359L18.3 9.78359L12.3 5.28359L12 5.05859L11.7 5.28359L5.7 9.78359L5.5 9.93359V10.1836V19.1836ZM4.66 9.50762L4.66042 9.50678C4.76701 9.2931 4.91128 9.12203 5.09568 8.9868L5.0957 8.98682L5.1 8.98359L11.0969 4.48593C11.241 4.38155 11.3862 4.30689 11.5331 4.25794C11.6807 4.20873 11.8356 4.18359 12 4.18359C12.1644 4.18359 12.3193 4.20873 12.4669 4.25794C12.6138 4.30689 12.759 4.38154 12.9031 4.48592L18.9 8.98359L18.9 8.98362L18.9043 8.9868C19.0888 9.1221 19.2335 9.29334 19.3408 9.50728C19.4474 9.72113 19.5 9.94457 19.5 10.1836V19.1836C19.5 19.5998 19.3578 19.9439 19.0597 20.2428C18.7607 20.5413 18.4164 20.6836 18 20.6836H13.5V15.1836V14.6836H13H11H10.5V15.1836V20.6836H6C5.58354 20.6836 5.23978 20.5413 4.94155 20.243C4.64248 19.944 4.5 19.5998 4.5 19.1836V10.1836C4.5 9.94477 4.55282 9.72148 4.66 9.50762ZM4.213 9.28359C4.35433 9.00026 4.55 8.76693 4.8 8.58359L4.213 9.28359Z"
      stroke="#637E85"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DashboardIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V8C4 8.53043 4.21071 9.03914 4.58579 9.41421C4.96086 9.78929 5.46957 10 6 10H8C8.53043 10 9.03914 9.78929 9.41421 9.41421C9.78929 9.03914 10 8.53043 10 8V6C10 5.46957 9.78929 4.96086 9.41421 4.58579C9.03914 4.21071 8.53043 4 8 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579Z"
      className="svgicon stroke"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5858 4.58579C14.2107 4.96086 14 5.46957 14 6V8C14 8.53043 14.2107 9.03914 14.5858 9.41421C14.9609 9.78929 15.4696 10 16 10H18C18.5304 10 19.0391 9.78929 19.4142 9.41421C19.7893 9.03914 20 8.53043 20 8V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4H16C15.4696 4 14.9609 4.21071 14.5858 4.58579Z"
      className="svgicon stroke"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.58579 14.5858C4.21071 14.9609 4 15.4696 4 16V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H8C8.53043 20 9.03914 19.7893 9.41421 19.4142C9.78929 19.0391 10 18.5304 10 18V16C10 15.4696 9.78929 14.9609 9.41421 14.5858C9.03914 14.2107 8.53043 14 8 14H6C5.46957 14 4.96086 14.2107 4.58579 14.5858Z"
      className="svgicon stroke"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5858 14.5858C14.2107 14.9609 14 15.4696 14 16V18C14 18.5304 14.2107 19.0391 14.5858 19.4142C14.9609 19.7893 15.4696 20 16 20H18C18.5304 20 19.0391 19.7893 19.4142 19.4142C19.7893 19.0391 20 18.5304 20 18V16C20 15.4696 19.7893 14.9609 19.4142 14.5858C19.0391 14.2107 18.5304 14 18 14H16C15.4696 14 14.9609 14.2107 14.5858 14.5858Z"
      className="svgicon stroke"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const DashboardIconActive = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V8C4 8.53043 4.21071 9.03914 4.58579 9.41421C4.96086 9.78929 5.46957 10 6 10H8C8.53043 10 9.03914 9.78929 9.41421 9.41421C9.78929 9.03914 10 8.53043 10 8V6C10 5.46957 9.78929 4.96086 9.41421 4.58579C9.03914 4.21071 8.53043 4 8 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579Z"
      className="svgicon-primary stroke fill"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5858 4.58579C14.2107 4.96086 14 5.46957 14 6V8C14 8.53043 14.2107 9.03914 14.5858 9.41421C14.9609 9.78929 15.4696 10 16 10H18C18.5304 10 19.0391 9.78929 19.4142 9.41421C19.7893 9.03914 20 8.53043 20 8V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4H16C15.4696 4 14.9609 4.21071 14.5858 4.58579Z"
      className="svgicon-primary stroke fill"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.58579 14.5858C4.21071 14.9609 4 15.4696 4 16V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H8C8.53043 20 9.03914 19.7893 9.41421 19.4142C9.78929 19.0391 10 18.5304 10 18V16C10 15.4696 9.78929 14.9609 9.41421 14.5858C9.03914 14.2107 8.53043 14 8 14H6C5.46957 14 4.96086 14.2107 4.58579 14.5858Z"
      className="svgicon-primary stroke fill"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5858 14.5858C14.2107 14.9609 14 15.4696 14 16V18C14 18.5304 14.2107 19.0391 14.5858 19.4142C14.9609 19.7893 15.4696 20 16 20H18C18.5304 20 19.0391 19.7893 19.4142 19.4142C19.7893 19.0391 20 18.5304 20 18V16C20 15.4696 19.7893 14.9609 19.4142 14.5858C19.0391 14.2107 18.5304 14 18 14H16C15.4696 14 14.9609 14.2107 14.5858 14.5858Z"
      className="svgicon-primary stroke fill"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ParticipantIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20"
    viewBox="0 -960 960 960"
    width="20"
    className="side-bar-icon"
  >
    <path
      d="M40-272q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v32q0 33-23.5 56.5T600-160H120q-33 0-56.5-23.5T40-240v-32Zm800 112H738q11-18 16.5-38.5T760-240v-40q0-44-24.5-84.5T666-434q51 6 96 20.5t84 35.5q36 20 55 44.5t19 53.5v40q0 33-23.5 56.5T840-160ZM360-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm400-160q0 66-47 113t-113 47q-11 0-28-2.5t-28-5.5q27-32 41.5-71t14.5-81q0-42-14.5-81T544-792q14-5 28-6.5t28-1.5q66 0 113 47t47 113ZM120-240h480v-32q0-11-5.5-20T580-306q-54-27-109-40.5T360-360q-56 0-111 13.5T140-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T440-640q0-33-23.5-56.5T360-720q-33 0-56.5 23.5T280-640q0 33 23.5 56.5T360-560Zm0 320Zm0-400Z"
      className="svgicon fill stroke"
    />
  </svg>
);

export const ParticipantIconActive = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 20C1.71667 20 1.47933 19.904 1.288 19.712C1.096 19.5207 1 19.2833 1 19V17.2C1 16.6333 1.146 16.1123 1.438 15.637C1.72933 15.1623 2.11667 14.8 2.6 14.55C3.63333 14.0333 4.68333 13.6457 5.75 13.387C6.81667 13.129 7.9 13 9 13C10.1 13 11.1833 13.129 12.25 13.387C13.3167 13.6457 14.3667 14.0333 15.4 14.55C15.8833 14.8 16.2707 15.1623 16.562 15.637C16.854 16.1123 17 16.6333 17 17.2V19C17 19.2833 16.904 19.5207 16.712 19.712C16.5207 19.904 16.2833 20 16 20H2ZM18.525 20C18.675 19.8833 18.7917 19.7373 18.875 19.562C18.9583 19.3873 19 19.1917 19 18.975V17C19 16.2667 18.796 15.5623 18.388 14.887C17.9793 14.2123 17.4 13.6333 16.65 13.15C17.5 13.25 18.3 13.4207 19.05 13.662C19.8 13.904 20.5 14.2 21.15 14.55C21.75 14.8833 22.2083 15.254 22.525 15.662C22.8417 16.0707 23 16.5167 23 17V19C23 19.2833 22.904 19.5207 22.712 19.712C22.5207 19.904 22.2833 20 22 20H18.525ZM9 12C7.9 12 6.95833 11.6083 6.175 10.825C5.39167 10.0417 5 9.1 5 8C5 6.9 5.39167 5.95833 6.175 5.175C6.95833 4.39167 7.9 4 9 4C10.1 4 11.0417 4.39167 11.825 5.175C12.6083 5.95833 13 6.9 13 8C13 9.1 12.6083 10.0417 11.825 10.825C11.0417 11.6083 10.1 12 9 12ZM19 8C19 9.1 18.6083 10.0417 17.825 10.825C17.0417 11.6083 16.1 12 15 12C14.8167 12 14.5833 11.9793 14.3 11.938C14.0167 11.896 13.7833 11.85 13.6 11.8C14.05 11.2667 14.3957 10.675 14.637 10.025C14.879 9.375 15 8.7 15 8C15 7.3 14.879 6.625 14.637 5.975C14.3957 5.325 14.05 4.73333 13.6 4.2C13.8333 4.11667 14.0667 4.06233 14.3 4.037C14.5333 4.01233 14.7667 4 15 4C16.1 4 17.0417 4.39167 17.825 5.175C18.6083 5.95833 19 6.9 19 8Z"
      className="svgicon-primary fill"
    />
  </svg>
);

export const StudyBuilderIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <path
      d="M19.0279 9.13783L19.0276 9.13778C18.7938 9.08767 18.5475 9.0501 18.2887 9.02506C18.03 9.00002 17.7671 8.9875 17.5 8.9875C17.0659 8.9875 16.64 9.02924 16.2225 9.11274C15.8053 9.19618 15.4048 9.30466 15.0209 9.43819L15.0209 9.43819L15.0205 9.43835C14.7227 9.55413 14.4817 9.54486 14.2946 9.41474C14.1073 9.2844 14.0125 9.07221 14.0125 8.775C14.0125 8.62814 14.0655 8.47639 14.1728 8.31956C14.2802 8.16269 14.3991 8.06062 14.5292 8.01176C15.0119 7.84533 15.4945 7.72052 15.9771 7.63732C16.4597 7.55412 16.9673 7.5125 17.5 7.5125C17.8328 7.5125 18.1614 7.5333 18.4859 7.5749C18.8106 7.61652 19.131 7.67063 19.4473 7.73721C19.5942 7.76987 19.721 7.85148 19.8278 7.98288C19.9344 8.11406 19.9875 8.2613 19.9875 8.425C19.9875 8.70545 19.8969 8.9095 19.7176 9.03989C19.538 9.17051 19.3087 9.20392 19.0279 9.13783ZM19.0279 14.6378L19.0276 14.6378C18.7938 14.5877 18.5475 14.5501 18.2887 14.5251C18.03 14.5 17.7671 14.4875 17.5 14.4875C17.0659 14.4875 16.6402 14.5251 16.2228 14.6002C15.8055 14.6753 15.4049 14.7796 15.0209 14.9132L15.0209 14.9132L15.0205 14.9134C14.7226 15.0292 14.4814 15.024 14.2943 14.902C14.1073 14.78 14.0125 14.5722 14.0125 14.275C14.0125 14.1281 14.0655 13.9764 14.1728 13.8196C14.2802 13.6627 14.3991 13.5606 14.5292 13.5118C15.0119 13.3453 15.4945 13.2205 15.9771 13.1373C16.4597 13.0541 16.9673 13.0125 17.5 13.0125C17.8328 13.0125 18.1614 13.0333 18.4859 13.0749C18.8106 13.1165 19.131 13.1706 19.4473 13.2372C19.5942 13.2699 19.721 13.3515 19.8278 13.4829C19.9344 13.6141 19.9875 13.7613 19.9875 13.925C19.9875 14.2054 19.8969 14.4095 19.7176 14.5399C19.538 14.6705 19.3087 14.7039 19.0279 14.6378ZM19.0279 11.8878L19.0276 11.8878C18.7938 11.8377 18.5475 11.8001 18.2887 11.7751C18.03 11.75 17.7671 11.7375 17.5 11.7375C17.0659 11.7375 16.64 11.7792 16.2225 11.8627C15.8053 11.9462 15.4048 12.0547 15.0209 12.1882L15.0209 12.1882L15.0205 12.1883C14.7227 12.3041 14.4817 12.2949 14.2946 12.1647C14.1073 12.0344 14.0125 11.8222 14.0125 11.525C14.0125 11.3781 14.0655 11.2264 14.1728 11.0696C14.2802 10.9127 14.3991 10.8106 14.5292 10.7618C15.0119 10.5953 15.4945 10.4705 15.9771 10.3873C16.4597 10.3041 16.9673 10.2625 17.5 10.2625C17.8328 10.2625 18.1614 10.2833 18.4859 10.3249C18.8106 10.3665 19.131 10.4206 19.4473 10.4872C19.5942 10.5199 19.721 10.6015 19.8278 10.7329C19.9344 10.8641 19.9875 11.0113 19.9875 11.175C19.9875 11.4554 19.8969 11.6595 19.7176 11.7899C19.538 11.9205 19.3087 11.9539 19.0279 11.8878ZM10.9946 17.0613L11.0125 17.0698V17.05V7.2H11.0247L11.0063 7.18921C10.322 6.78863 9.59593 6.48819 8.82816 6.2879C8.06047 6.08764 7.28441 5.9875 6.5 5.9875C5.89918 5.9875 5.30254 6.04591 4.71008 6.16274C4.11758 6.27957 3.54592 6.45482 2.99512 6.68849L2.9875 6.67054V6.7V16.6V16.6175L3.00405 16.6118C3.5868 16.412 4.16533 16.2622 4.73964 16.1623C5.31391 16.0624 5.9007 16.0125 6.5 16.0125C7.28239 16.0125 8.04393 16.0999 8.78463 16.2747C9.52537 16.4494 10.262 16.7116 10.9946 17.0613ZM12.9875 17.05V17.0698L13.0054 17.0613C13.738 16.7116 14.4746 16.4494 15.2154 16.2747C15.9561 16.0999 16.7176 16.0125 17.5 16.0125C18.0993 16.0125 18.6861 16.0624 19.2604 16.1623C19.8347 16.2622 20.4132 16.412 20.9959 16.6118L21.0125 16.6175V16.6V6.7H21.032L21.0049 6.68849C20.4541 6.45482 19.8824 6.27957 19.2899 6.16274C18.6975 6.04591 18.1008 5.9875 17.5 5.9875C16.7156 5.9875 15.9395 6.08764 15.1718 6.2879C14.4041 6.48819 13.678 6.78863 12.9937 7.18921L12.9875 7.17865V7.2V17.05ZM1.55517 5.21138L1.55518 5.2114L1.55578 5.21108C2.32155 4.81155 3.12059 4.51191 3.95292 4.31215C4.78528 4.11239 5.6343 4.0125 6.5 4.0125C7.46558 4.0125 8.41031 4.13736 9.33424 4.38707C10.2581 4.63677 11.1446 5.01132 11.9937 5.51077L11.987 5.52218L12.0063 5.51077C12.8554 5.01132 13.7419 4.63677 14.6658 4.38707C15.5897 4.13736 16.5344 4.0125 17.5 4.0125C18.3657 4.0125 19.2147 4.11239 20.0471 4.31215C20.8794 4.51191 21.6785 4.81155 22.4442 5.21108L22.4442 5.2111L22.4448 5.21138C22.6259 5.29367 22.7613 5.41686 22.8515 5.58102C22.9422 5.74592 22.9875 5.91885 22.9875 6.1V18.15C22.9875 18.529 22.8272 18.8166 22.5059 19.0144C22.1849 19.2119 21.8521 19.2203 21.5058 19.0389C20.8883 18.7052 20.2417 18.4465 19.5658 18.2629C18.8897 18.0793 18.2011 17.9875 17.5 17.9875C16.7489 17.9875 16.0145 18.0835 15.2968 18.2754C14.5791 18.4674 13.8947 18.7553 13.2438 19.1391C13.0614 19.2386 12.8665 19.3174 12.6591 19.3755C12.452 19.4335 12.2323 19.4625 12 19.4625C11.7677 19.4625 11.548 19.4335 11.3409 19.3755C11.1335 19.3174 10.9386 19.2386 10.7562 19.1391C10.1053 18.7553 9.42094 18.4674 8.70323 18.2754C7.9855 18.0835 7.25108 17.9875 6.5 17.9875C5.79889 17.9875 5.11029 18.0793 4.43422 18.2629C3.75832 18.4465 3.11162 18.7052 2.49413 19.039C2.14789 19.2203 1.81512 19.2119 1.49405 19.0144C1.17277 18.8166 1.0125 18.529 1.0125 18.15V6.1C1.0125 5.91885 1.05776 5.74592 1.14845 5.58102C1.23874 5.41686 1.37414 5.29367 1.55517 5.21138Z"
      strokeWidth="0.025"
      className="svgicon fill stroke"
    />
  </svg>
);

export const StudyBuilderIconActive = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5714_5593)">
      <path
        d="M17.5 4.5C15.55 4.5 13.45 4.9 12 6C10.55 4.9 8.45 4.5 6.5 4.5C5.05 4.5 3.51 4.72 2.22 5.29C1.49 5.62 1 6.33 1 7.14V18.42C1 19.72 2.22 20.68 3.48 20.36C4.46 20.11 5.5 20 6.5 20C8.06 20 9.72 20.26 11.06 20.92C11.66 21.22 12.34 21.22 12.93 20.92C14.27 20.25 15.93 20 17.49 20C18.49 20 19.53 20.11 20.51 20.36C21.77 20.69 22.99 19.73 22.99 18.42V7.14C22.99 6.33 22.5 5.62 21.77 5.29C20.49 4.72 18.95 4.5 17.5 4.5ZM21 17.23C21 17.86 20.42 18.32 19.8 18.21C19.05 18.07 18.27 18.01 17.5 18.01C15.8 18.01 13.35 18.66 12 19.51V8C13.35 7.15 15.8 6.5 17.5 6.5C18.42 6.5 19.33 6.59 20.2 6.78C20.66 6.88 21 7.29 21 7.76V17.23Z"
        className="svgicon-primary fill"
      />
      <path
        d="M13.9799 11.0099C13.6599 11.0099 13.3699 10.8099 13.2699 10.4899C13.1399 10.0999 13.3599 9.66986 13.7499 9.54986C15.2899 9.04986 17.2799 8.88986 19.1099 9.09986C19.5199 9.14986 19.8199 9.51986 19.7699 9.92986C19.7199 10.3399 19.3499 10.6399 18.9399 10.5899C17.3199 10.3999 15.5499 10.5499 14.2099 10.9799C14.1299 10.9899 14.0499 11.0099 13.9799 11.0099Z"
        className="svgicon-primary fill"
      />
      <path
        d="M13.9799 13.67C13.6599 13.67 13.3699 13.47 13.2699 13.15C13.1399 12.76 13.3599 12.33 13.7499 12.21C15.2799 11.71 17.2799 11.55 19.1099 11.76C19.5199 11.81 19.8199 12.18 19.7699 12.59C19.7199 13 19.3499 13.3 18.9399 13.25C17.3199 13.06 15.5499 13.21 14.2099 13.64C14.1299 13.66 14.0499 13.67 13.9799 13.67Z"
        className="svgicon-primary fill"
      />
      <path
        d="M13.9799 16.3302C13.6599 16.3302 13.3699 16.1302 13.2699 15.8102C13.1399 15.4202 13.3599 14.9902 13.7499 14.8702C15.2799 14.3702 17.2799 14.2102 19.1099 14.4202C19.5199 14.4702 19.8199 14.8402 19.7699 15.2502C19.7199 15.6602 19.3499 15.9502 18.9399 15.9102C17.3199 15.7202 15.5499 15.8702 14.2099 16.3002C14.1299 16.3202 14.0499 16.3302 13.9799 16.3302Z"
        className="svgicon-primary fill"
      />
    </g>
    <defs>
      <clipPath id="clip0_5714_5593">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AddonsIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 11.1726H14.9875V11.1851V13.1851C14.9875 13.4652 14.8929 13.6995 14.7037 13.8887C14.5145 14.0779 14.2802 14.1726 14 14.1726C13.7198 14.1726 13.4855 14.0779 13.2963 13.8887C13.1071 13.6995 13.0125 13.4652 13.0125 13.1851V11.1851V11.1726H13H11C10.7198 11.1726 10.4855 11.0779 10.2963 10.8887C10.1071 10.6995 10.0125 10.4652 10.0125 10.1851C10.0125 9.90487 10.1071 9.6706 10.2963 9.4814C10.4855 9.29219 10.7198 9.19756 11 9.19756H13H13.0125V9.18506V7.18506C13.0125 6.90487 13.1071 6.6706 13.2963 6.4814C13.4855 6.29219 13.7198 6.19756 14 6.19756C14.2802 6.19756 14.5145 6.29219 14.7037 6.4814C14.8929 6.6706 14.9875 6.90487 14.9875 7.18506V9.18506V9.19756H15H17C17.2802 9.19756 17.5145 9.29219 17.7037 9.4814C17.8929 9.6706 17.9875 9.90487 17.9875 10.1851C17.9875 10.4652 17.8929 10.6995 17.7037 10.8887C17.5145 11.0779 17.2802 11.1726 17 11.1726H15ZM7.9875 16.1851V16.1976H8H20H20.0125V16.1851V4.18506V4.17256H20H8H7.9875V4.18506V16.1851ZM3.9875 20.1851V20.1976H4H17C17.2802 20.1976 17.5145 20.2922 17.7037 20.4814C17.8929 20.6706 17.9875 20.9049 17.9875 21.1851C17.9875 21.4652 17.8929 21.6995 17.7037 21.8887C17.5145 22.0779 17.2802 22.1726 17 22.1726H4C3.45334 22.1726 2.98568 21.9781 2.59634 21.5887C2.207 21.1994 2.0125 20.7317 2.0125 20.1851V7.18506C2.0125 6.90487 2.10713 6.6706 2.29634 6.4814C2.48555 6.29219 2.71981 6.19756 3 6.19756C3.28019 6.19756 3.51445 6.29219 3.70366 6.4814C3.89287 6.6706 3.9875 6.90487 3.9875 7.18506V20.1851ZM8 18.1726C7.45334 18.1726 6.98568 17.9781 6.59634 17.5887C6.207 17.1994 6.0125 16.7317 6.0125 16.1851V4.18506C6.0125 3.6384 6.207 3.17074 6.59634 2.7814C6.98568 2.39206 7.45334 2.19756 8 2.19756H20C20.5467 2.19756 21.0143 2.39206 21.4037 2.7814C21.793 3.17074 21.9875 3.6384 21.9875 4.18506V16.1851C21.9875 16.7317 21.793 17.1994 21.4037 17.5887C21.0143 17.9781 20.5467 18.1726 20 18.1726H8Z"
      strokeWidth="0.025"
      className="svgicon fill stroke"
    />
  </svg>
);
export const AddonsIconActive = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M14 14C14.2833 14 14.5208 13.9042 14.7125 13.7125C14.9042 13.5208 15 13.2833 15 13V11H17C17.2833 11 17.5208 10.9042 17.7125 10.7125C17.9042 10.5208 18 10.2833 18 10C18 9.71667 17.9042 9.47917 17.7125 9.2875C17.5208 9.09583 17.2833 9 17 9H15V7C15 6.71667 14.9042 6.47917 14.7125 6.2875C14.5208 6.09583 14.2833 6 14 6C13.7167 6 13.4792 6.09583 13.2875 6.2875C13.0958 6.47917 13 6.71667 13 7V9H11C10.7167 9 10.4792 9.09583 10.2875 9.2875C10.0958 9.47917 10 9.71667 10 10C10 10.2833 10.0958 10.5208 10.2875 10.7125C10.4792 10.9042 10.7167 11 11 11H13V13C13 13.2833 13.0958 13.5208 13.2875 13.7125C13.4792 13.9042 13.7167 14 14 14ZM8 18C7.45 18 6.97917 17.8042 6.5875 17.4125C6.19583 17.0208 6 16.55 6 16V4C6 3.45 6.19583 2.97917 6.5875 2.5875C6.97917 2.19583 7.45 2 8 2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V16C22 16.55 21.8042 17.0208 21.4125 17.4125C21.0208 17.8042 20.55 18 20 18H8ZM4 22C3.45 22 2.97917 21.8042 2.5875 21.4125C2.19583 21.0208 2 20.55 2 20V7C2 6.71667 2.09583 6.47917 2.2875 6.2875C2.47917 6.09583 2.71667 6 3 6C3.28333 6 3.52083 6.09583 3.7125 6.2875C3.90417 6.47917 4 6.71667 4 7V20H17C17.2833 20 17.5208 20.0958 17.7125 20.2875C17.9042 20.4792 18 20.7167 18 21C18 21.2833 17.9042 21.5208 17.7125 21.7125C17.5208 21.9042 17.2833 22 17 22H4Z"
      className="svgicon-primary fill"
    />
  </svg>
);

export const TrackingIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12.9875 10.275H12.976L12.9935 10.2857C13.2919 10.468 13.5321 10.7042 13.7144 10.9942C13.8964 11.2836 13.9875 11.6187 13.9875 12C13.9875 12.5467 13.793 13.0143 13.4037 13.4037C13.0143 13.793 12.5467 13.9875 12 13.9875C11.4533 13.9875 10.9857 13.793 10.5963 13.4037C10.207 13.0143 10.0125 12.5467 10.0125 12C10.0125 11.6188 10.1036 11.2794 10.2857 10.9815C10.4679 10.6833 10.708 10.4515 11.0061 10.2859L11.0125 10.2975V10.275V8.125V8.10869L10.9967 8.11293C10.1275 8.34696 9.40855 8.8193 8.84024 9.52969C8.27174 10.2403 7.9875 11.0639 7.9875 12C7.9875 13.1033 8.3805 14.0482 9.16616 14.8338C9.95182 15.6195 10.8967 16.0125 12 16.0125C13.1033 16.0125 14.0482 15.6195 14.8338 14.8338C15.6195 14.0482 16.0125 13.1033 16.0125 12C16.0125 11.5655 15.9498 11.1641 15.8243 10.796C15.699 10.4283 15.5277 10.0774 15.3105 9.74319L15.3105 9.74318L15.3102 9.74273C15.1451 9.5117 15.071 9.25618 15.0875 8.97573C15.104 8.69514 15.2029 8.4648 15.3838 8.28384C15.5816 8.08611 15.8159 7.9875 16.0875 7.9875C16.3583 7.9875 16.5754 8.10205 16.7398 8.33227L16.74 8.33245C17.1226 8.84813 17.4262 9.41373 17.6508 10.0293C17.8752 10.6445 17.9875 11.3014 17.9875 12C17.9875 13.6634 17.4055 15.0769 16.2412 16.2412C15.0769 17.4055 13.6634 17.9875 12 17.9875C10.3366 17.9875 8.92313 17.4055 7.75884 16.2412C6.59454 15.0769 6.0125 13.6634 6.0125 12C6.0125 10.5029 6.48649 9.20164 7.43449 8.09563C8.38258 6.98953 9.5716 6.32019 11.002 6.08734L11.0125 6.08563V6.075V4.05V4.03583L10.9984 4.0376C9.01209 4.28798 7.34684 5.16444 6.00318 6.66667C4.65942 8.16901 3.9875 9.94699 3.9875 12C3.9875 14.2366 4.76377 16.1314 6.31616 17.6838C7.86855 19.2362 9.76342 20.0125 12 20.0125C14.2366 20.0125 16.1314 19.2362 17.6838 17.6838C19.2362 16.1314 20.0125 14.2366 20.0125 12C20.0125 11.0319 19.8539 10.118 19.5367 9.25817C19.2196 8.39851 18.7689 7.6181 18.1846 6.917L18.1845 6.91693C18.0031 6.70251 17.9125 6.45537 17.9125 6.175C17.9125 5.89498 18.0112 5.65649 18.2088 5.45884C18.4065 5.2612 18.6407 5.16677 18.9121 5.17499C19.1835 5.18322 19.4093 5.29402 19.5905 5.50807L19.5905 5.50809C20.3396 6.39034 20.9263 7.38079 21.3508 8.47951C21.7753 9.57798 21.9875 10.7514 21.9875 12C21.9875 13.3817 21.7253 14.68 21.201 15.895C20.6766 17.1103 19.965 18.1673 19.0662 19.0662C18.1673 19.965 17.1103 20.6766 15.895 21.201C14.68 21.7253 13.3817 21.9875 12 21.9875C10.6183 21.9875 9.31999 21.7253 8.10495 21.201C6.88968 20.6766 5.83268 19.965 4.93384 19.0662C4.035 18.1673 3.32338 17.1103 2.79898 15.895C2.27468 14.68 2.0125 13.3817 2.0125 12C2.0125 10.6183 2.27468 9.31999 2.79898 8.10495C3.32338 6.88968 4.035 5.83268 4.93384 4.93384C5.83268 4.035 6.88968 3.32338 8.10495 2.79898C9.31999 2.27468 10.6183 2.0125 12 2.0125C12.2802 2.0125 12.5145 2.10713 12.7037 2.29634C12.8929 2.48555 12.9875 2.71981 12.9875 3V10.275Z"
      strokeWidth="0.025"
      className="svgicon fill stroke"
    />
  </svg>
);

export const TrackingIconActive = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C12.2833 2 12.5208 2.09583 12.7125 2.2875C12.9042 2.47917 13 2.71667 13 3V10.275C13.3 10.4583 13.5417 10.6958 13.725 10.9875C13.9083 11.2792 14 11.6167 14 12C14 12.55 13.8042 13.0208 13.4125 13.4125C13.0208 13.8042 12.55 14 12 14C11.45 14 10.9792 13.8042 10.5875 13.4125C10.1958 13.0208 10 12.55 10 12C10 11.6167 10.0917 11.275 10.275 10.975C10.4583 10.675 10.7 10.4417 11 10.275V8.125C10.1333 8.35833 9.41667 8.82917 8.85 9.5375C8.28333 10.2458 8 11.0667 8 12C8 13.1 8.39167 14.0417 9.175 14.825C9.95833 15.6083 10.9 16 12 16C13.1 16 14.0417 15.6083 14.825 14.825C15.6083 14.0417 16 13.1 16 12C16 11.5667 15.9375 11.1667 15.8125 10.8C15.6875 10.4333 15.5167 10.0833 15.3 9.75C15.1333 9.51667 15.0583 9.25833 15.075 8.975C15.0917 8.69167 15.1917 8.45833 15.375 8.275C15.575 8.075 15.8125 7.975 16.0875 7.975C16.3625 7.975 16.5833 8.09167 16.75 8.325C17.1333 8.84167 17.4375 9.40833 17.6625 10.025C17.8875 10.6417 18 11.3 18 12C18 13.6667 17.4167 15.0833 16.25 16.25C15.0833 17.4167 13.6667 18 12 18C10.3333 18 8.91667 17.4167 7.75 16.25C6.58333 15.0833 6 13.6667 6 12C6 10.5 6.475 9.19583 7.425 8.0875C8.375 6.97917 9.56667 6.30833 11 6.075V4.05C9.01667 4.3 7.35417 5.175 6.0125 6.675C4.67083 8.175 4 9.95 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 11.0333 19.8417 10.1208 19.525 9.2625C19.2083 8.40417 18.7583 7.625 18.175 6.925C17.9917 6.70833 17.9 6.45833 17.9 6.175C17.9 5.89167 18 5.65 18.2 5.45C18.4 5.25 18.6375 5.15417 18.9125 5.1625C19.1875 5.17083 19.4167 5.28333 19.6 5.5C20.35 6.38333 20.9375 7.375 21.3625 8.475C21.7875 9.575 22 10.75 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
      fill="#327091"
      className="svgicon-primary fill"
    />
  </svg>
);

export const StudySettingsIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.675 4.317C13.249 2.561 10.751 2.561 10.325 4.317C10.049 5.452 8.749 5.99 7.753 5.382C6.209 4.442 4.443 6.209 5.383 7.752C5.5243 7.98375 5.60889 8.24559 5.62987 8.51621C5.65085 8.78683 5.60764 9.05859 5.50375 9.30935C5.39985 9.56011 5.23822 9.7828 5.032 9.95929C4.82578 10.1358 4.5808 10.2611 4.317 10.325C2.561 10.751 2.561 13.249 4.317 13.675C4.58056 13.7391 4.82529 13.8645 5.03127 14.0409C5.23726 14.2174 5.3987 14.44 5.50247 14.6906C5.60624 14.9412 5.64942 15.2128 5.62848 15.4832C5.60755 15.7537 5.5231 16.0153 5.382 16.247C4.442 17.791 6.209 19.557 7.752 18.617C7.98375 18.4757 8.24559 18.3911 8.51621 18.3701C8.78683 18.3491 9.05859 18.3924 9.30935 18.4963C9.56011 18.6001 9.7828 18.7618 9.95929 18.968C10.1358 19.1742 10.2611 19.4192 10.325 19.683C10.751 21.439 13.249 21.439 13.675 19.683C13.7391 19.4194 13.8645 19.1747 14.0409 18.9687C14.2174 18.7627 14.44 18.6013 14.6906 18.4975C14.9412 18.3938 15.2128 18.3506 15.4832 18.3715C15.7537 18.3924 16.0153 18.4769 16.247 18.618C17.791 19.558 19.557 17.791 18.617 16.248C18.4757 16.0162 18.3911 15.7544 18.3701 15.4838C18.3491 15.2132 18.3924 14.9414 18.4963 14.6907C18.6001 14.4399 18.7618 14.2172 18.968 14.0407C19.1742 13.8642 19.4192 13.7389 19.683 13.675C21.439 13.249 21.439 10.751 19.683 10.325C19.4194 10.2609 19.1747 10.1355 18.9687 9.95905C18.7627 9.78258 18.6013 9.55999 18.4975 9.30938C18.3938 9.05877 18.3506 8.78721 18.3715 8.51677C18.3924 8.24634 18.4769 7.98466 18.618 7.753C19.558 6.209 17.791 4.443 16.248 5.383C16.0162 5.5243 15.7544 5.60889 15.4838 5.62987C15.2132 5.65085 14.9414 5.60764 14.6907 5.50375C14.4399 5.39985 14.2172 5.23822 14.0407 5.032C13.8642 4.82578 13.7389 4.5808 13.675 4.317Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="svgicon stroke"
    />
    <path
      d="M14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="svgicon stroke"
    />
  </svg>
);

export const StudySettingsIconActive = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7881 3.80244C13.3321 1.93044 10.6681 1.93044 10.2121 3.80244C10.144 4.08374 10.0105 4.34499 9.82236 4.56493C9.63424 4.78487 9.39685 4.95729 9.1295 5.06816C8.86216 5.17903 8.57242 5.22521 8.28386 5.20294C7.99529 5.18068 7.71606 5.0906 7.46889 4.94004C5.82249 3.93684 3.93849 5.82084 4.94169 7.46724C5.58969 8.53044 5.01489 9.91764 3.80529 10.2116C1.93209 10.6664 1.93209 13.3316 3.80529 13.7852C4.08666 13.8534 4.34796 13.9871 4.5679 14.1753C4.78785 14.3636 4.96022 14.6011 5.07098 14.8686C5.18174 15.1361 5.22776 15.426 5.20529 15.7146C5.18283 16.0033 5.09251 16.2825 4.94169 16.5296C3.93849 18.176 5.82249 20.06 7.46889 19.0568C7.71602 18.906 7.99527 18.8157 8.28391 18.7932C8.57255 18.7708 8.86242 18.8168 9.12991 18.9276C9.39739 19.0383 9.63494 19.2107 9.8232 19.4306C10.0115 19.6506 10.1451 19.9119 10.2133 20.1932C10.6681 22.0664 13.3333 22.0664 13.7869 20.1932C13.8553 19.912 13.9891 19.6509 14.1774 19.4311C14.3657 19.2113 14.6032 19.039 14.8706 18.9283C15.138 18.8176 15.4278 18.7715 15.7163 18.7939C16.0049 18.8162 16.2841 18.9063 16.5313 19.0568C18.1777 20.06 20.0617 18.176 19.0585 16.5296C18.9079 16.2825 18.8178 16.0032 18.7955 15.7147C18.7732 15.4261 18.8192 15.1363 18.93 14.8689C19.0407 14.6015 19.213 14.364 19.4328 14.1757C19.6525 13.9874 19.9137 13.8536 20.1949 13.7852C22.0681 13.3304 22.0681 10.6652 20.1949 10.2116C19.9135 10.1435 19.6522 10.0098 19.4323 9.82155C19.2123 9.63329 19.04 9.39574 18.9292 9.12825C18.8184 8.86077 18.7724 8.5709 18.7949 8.28226C18.8174 7.99362 18.9077 7.71437 19.0585 7.46724C20.0617 5.82084 18.1777 3.93684 16.5313 4.94004C16.2842 5.09085 16.0049 5.18117 15.7163 5.20364C15.4276 5.22611 15.1378 5.18009 14.8703 5.06932C14.6028 4.95856 14.3652 4.78619 14.177 4.56625C13.9887 4.34631 13.8551 4.08501 13.7869 3.80364L13.7881 3.80244ZM12.0001 15.5984C12.9549 15.5984 13.8705 15.2192 14.5457 14.544C15.2208 13.8689 15.6001 12.9532 15.6001 11.9984C15.6001 11.0437 15.2208 10.128 14.5457 9.45285C13.8705 8.77772 12.9549 8.39844 12.0001 8.39844C11.0453 8.39844 10.1296 8.77772 9.45451 9.45285C8.77938 10.128 8.40009 11.0437 8.40009 11.9984C8.40009 12.9532 8.77938 13.8689 9.45451 14.544C10.1296 15.2192 11.0453 15.5984 12.0001 15.5984Z"
      className="svgicon-primary fill"
    />
  </svg>
);

export const AuditTrailIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V9.414C18.9999 9.1488 18.8946 8.89449 18.707 8.707L13.293 3.293C13.1055 3.10545 12.8512 3.00006 12.586 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V16M5 21L9.879 16.121M9.879 16.121C10.1567 16.4033 10.4876 16.6279 10.8525 16.7817C11.2174 16.9355 11.6092 17.0156 12.0052 17.0173C12.4012 17.0189 12.7936 16.9421 13.1599 16.7914C13.5261 16.6406 13.8588 16.4188 14.1388 16.1388C14.4189 15.8588 14.6408 15.5262 14.7916 15.16C14.9425 14.7938 15.0193 14.4014 15.0177 14.0054C15.0162 13.6094 14.9362 13.2176 14.7825 12.8526C14.6287 12.4877 14.4043 12.1568 14.122 11.879C13.5579 11.3239 12.7973 11.0142 12.0059 11.0173C11.2145 11.0204 10.4564 11.3362 9.8967 11.8957C9.33702 12.4553 9.02111 13.2133 9.0178 14.0047C9.01448 14.7961 9.32402 15.5568 9.879 16.121Z"
      strokeWidth="2"
      strokeLinecap="round"
      className="svgicon stroke"
      strokeLinejoin="round"
    />
  </svg>
);
export const MahaloIcon = () => (
  <svg
    width="35"
    height="31"
    viewBox="0 0 52 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.14"
      d="M49.3315 25.5C49.3315 39.031 38.3625 50 24.8315 50C11.3005 50 0.331482 39.031 0.331482 25.5C0.331482 11.969 11.3005 1 24.8315 1C38.3625 1 49.3315 11.969 49.3315 25.5Z"
      fill="url(#paint0_linear_79_793)"
    />
    <path
      d="M42.1431 33.024V17.4652C42.1431 15.0159 40.1924 13.0303 37.786 13.0303C35.3796 13.0303 33.4288 15.0159 33.4288 17.4652V28.0451C33.8404 27.647 34.3862 27.3164 34.9235 27.5033C35.21 27.6029 35.4655 27.796 35.5823 28.1362C35.7671 28.6745 35.4744 29.2428 35.2125 29.747L34.0062 32.0698C33.9495 32.179 33.8785 32.2798 33.7952 32.3695C33.5599 32.6227 33.4288 32.958 33.4288 33.3065V34.1003C33.4288 35.9552 34.9061 37.4589 36.7285 37.4589H37.786C40.1924 37.4589 42.1431 35.4733 42.1431 33.024Z"
      fill="#9FF9E8"
    />
    <path
      d="M26.4289 33.174V17.3168C26.4289 14.8709 24.4462 12.8882 22.0003 12.8882C19.5545 12.8882 17.5717 14.8709 17.5717 17.3168V28.0786C17.9899 27.676 18.5481 27.3403 19.0959 27.5322C19.3894 27.635 19.6501 27.8344 19.7657 28.1861C19.9424 28.7239 19.653 29.2861 19.3912 29.7879L18.1586 32.1503C18.101 32.2608 18.0286 32.363 17.9436 32.4541C17.7046 32.7102 17.5717 33.0473 17.5717 33.3975V34.1955C17.5717 36.0772 19.0971 37.6026 20.9788 37.6026H22.0003C24.4462 37.6026 26.4289 35.6198 26.4289 33.174Z"
      fill="#849EFE"
    />
    <path
      d="M41.7084 22.8911C43.4553 21.1442 46.2768 21.1334 48.0104 22.867C49.744 24.6007 49.7333 27.4222 47.9864 29.1691L40.7178 36.4376C38.9709 38.1845 36.1494 38.1953 34.4158 36.4616C32.6822 34.728 32.6929 31.9065 34.4398 30.1596L41.7084 22.8911Z"
      fill="#10EAED"
    />
    <path
      d="M18.9161 14.2242C20.6426 12.4977 23.4418 12.4977 25.1682 14.2242C26.8947 15.9507 26.8947 18.7498 25.1682 20.4763L9.37833 36.2662C7.65186 37.9927 4.85269 37.9927 3.12622 36.2662C1.39974 34.5397 1.39974 31.7406 3.12622 30.0141L18.9161 14.2242Z"
      fill="url(#paint1_linear_79_793)"
    />
    <g filter="url(#filter0_bd_79_793)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.4302 14.643C17.8906 15.3768 17.5717 16.2831 17.5717 17.2638V28.0299C17.58 28.022 17.5884 28.014 17.5967 28.0061L25.1503 20.4504C25.9117 19.6888 26.3379 18.7188 26.4289 17.724V17.2638C26.4289 16.7739 26.3493 16.3025 26.2024 15.8619C25.9899 15.2496 25.6392 14.6747 25.1503 14.1857C23.4209 12.4557 20.6168 12.4557 18.8874 14.1856L18.4302 14.643Z"
        fill="url(#paint2_linear_79_793)"
      />
    </g>
    <path
      d="M34.5009 14.3884C36.2762 12.613 39.1546 12.613 40.9299 14.3884C42.7053 16.1637 42.7053 19.0421 40.9299 20.8175L25.0591 36.6883C23.2837 38.4636 20.4053 38.4636 18.63 36.6883C16.8547 34.913 16.8547 32.0346 18.63 30.2592L34.5009 14.3884Z"
      fill="url(#paint3_linear_79_793)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.5226 36.247C26.0919 35.4847 26.429 34.5388 26.429 33.5142V22.461C26.4205 22.4691 26.4119 22.4773 26.4033 22.4854L18.606 30.255C17.82 31.0382 17.38 32.0356 17.2861 33.0587V33.5142C17.2861 34.1457 17.4142 34.7472 17.6457 35.2943C17.8679 35.8036 18.188 36.2806 18.606 36.6971C20.3912 38.476 23.2857 38.476 25.071 36.6971L25.5226 36.247Z"
      fill="url(#paint4_linear_79_793)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41.2555 35.9747C41.8134 35.2334 42.143 34.3176 42.143 33.3264V22.46C42.1345 22.4681 42.1258 22.4762 42.1171 22.4842L34.32 30.1111C33.534 30.8799 33.0941 31.859 33.0001 32.8632V33.3264C33.0001 33.8293 33.085 34.3128 33.2415 34.764C33.4616 35.3741 33.8211 35.9469 34.32 36.4349C36.1052 38.1812 38.9997 38.1812 40.785 36.4349L41.2555 35.9747Z"
      fill="url(#paint5_linear_79_793)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.1444 14.8318C33.6044 15.5742 33.2858 16.4881 33.2858 17.4764V28.4577C33.2942 28.4496 33.3027 28.4415 33.3112 28.4334L40.9866 20.7351C41.7603 19.9592 42.1934 18.9709 42.2858 17.9573V17.4764C42.2858 17.0502 42.2266 16.6379 42.1159 16.2472C41.9092 15.5536 41.5328 14.9 40.9866 14.3522C39.2292 12.5896 36.38 12.5896 34.6226 14.3522L34.1444 14.8318Z"
      fill="url(#paint6_linear_79_793)"
    />
    <defs>
      <filter
        id="filter0_bd_79_793"
        x="-146.428"
        y="-151.112"
        width="336.857"
        height="343.142"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="82" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_79_793"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2" dy="3" />
        <feGaussianBlur stdDeviation="7.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_backgroundBlur_79_793"
          result="effect2_dropShadow_79_793"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_79_793"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_79_793"
        x1="9.02236"
        y1="44.7027"
        x2="43.7031"
        y2="9.93919"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3767F8" />
        <stop offset="0.481131" stopColor="#61D2F3" />
        <stop offset="1" stopColor="#10EAED" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_79_793"
        x1="24.3565"
        y1="13.5943"
        x2="3.13391"
        y2="36.2734"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2D23D4" />
        <stop offset="0.429794" stopColor="#2E48F3" />
        <stop offset="1" stopColor="#418CFD" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_79_793"
        x1="22.0003"
        y1="12.8882"
        x2="17.5695"
        y2="26.6771"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4C0CCF" />
        <stop offset="1" stopColor="#344CEF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_79_793"
        x1="36.5639"
        y1="17.238"
        x2="22.9675"
        y2="32.3661"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#49D7E9" />
        <stop offset="0.456979" stopColor="#71CEF9" />
        <stop offset="1" stopColor="#6EB4FE" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_79_793"
        x1="19.5004"
        y1="29.511"
        x2="26.5894"
        y2="35.3388"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#588AFD" />
        <stop offset="0.471686" stopColor="#649EFF" />
        <stop offset="1" stopColor="#6DAFFF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_79_793"
        x1="37.5716"
        y1="37.7446"
        x2="41.4631"
        y2="22.9926"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C8FCC6" />
        <stop offset="0.497488" stopColor="#95F8D2" />
        <stop offset="1" stopColor="#5EF1DA" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_79_793"
        x1="37.7858"
        y1="13.0303"
        x2="33.2613"
        y2="27.7277"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#15E6E8" />
        <stop offset="0.433113" stopColor="#36E8E5" />
        <stop offset="1" stopColor="#65E8E2" />
      </linearGradient>
    </defs>
  </svg>
);

export const AppointmentsIconActive = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M5.99844 5.30039H6.49844V4.80039V3.60039C6.49844 3.41474 6.57219 3.23669 6.70346 3.10542C6.83474 2.97414 7.01279 2.90039 7.19844 2.90039C7.38409 2.90039 7.56214 2.97414 7.69341 3.10542C7.82469 3.23669 7.89844 3.41474 7.89844 3.60039V4.80039V5.30039H8.39844H15.5984H16.0984V4.80039V3.60039C16.0984 3.41474 16.1722 3.23669 16.3035 3.10542C16.4347 2.97414 16.6128 2.90039 16.7984 2.90039C16.9841 2.90039 17.1621 2.97414 17.2934 3.10542C17.4247 3.23669 17.4984 3.41474 17.4984 3.60039V4.80039V5.30039H17.9984H19.1984C19.7023 5.30039 20.1856 5.50057 20.5419 5.85689C20.8983 6.21321 21.0984 6.69648 21.0984 7.20039V19.2004C21.0984 19.7043 20.8983 20.1876 20.5419 20.5439C20.1856 20.9002 19.7023 21.1004 19.1984 21.1004H4.79844C4.29453 21.1004 3.81125 20.9002 3.45493 20.5439C3.09862 20.1876 2.89844 19.7043 2.89844 19.2004V7.20039C2.89844 6.69648 3.09862 6.21321 3.45493 5.85689C3.81125 5.50057 4.29453 5.30039 4.79844 5.30039H5.99844ZM5.99636 10.8025L6.32634 10.4725L5.99636 10.8025C6.31517 11.1213 6.74757 11.3004 7.19844 11.3004H16.7984C17.2493 11.3004 17.6817 11.1213 18.0005 10.8025C18.3193 10.4837 18.4984 10.0513 18.4984 9.60039C18.4984 9.14952 18.3193 8.71712 18.0005 8.39831C17.6817 8.0795 17.2493 7.90039 16.7984 7.90039H7.19844C6.74757 7.90039 6.31517 8.0795 5.99636 8.39831C5.67754 8.71712 5.49844 9.14952 5.49844 9.60039C5.49844 10.0513 5.67754 10.4837 5.99636 10.8025Z"
      fill="#1B0ED8"
      stroke="#1B0ED8"
      className="svgicon-primary stroke fill"
    />
  </svg>
);

export const AppointmentsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M8 7V3M16 7V3M7 11H17M5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21Z"
      // stroke="#674F82"
      strokeWidth="2"
      className="svgicon stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MessagesIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 10.9661H8.01M12 10.9661H12.01M16 10.9661H16.01M9 16.9661H5C4.46957 16.9661 3.96086 16.7554 3.58579 16.3803C3.21071 16.0052 3 15.4965 3 14.9661V6.96609C3 6.43566 3.21071 5.92695 3.58579 5.55188C3.96086 5.17681 4.46957 4.96609 5 4.96609H19C19.5304 4.96609 20.0391 5.17681 20.4142 5.55188C20.7893 5.92695 21 6.43566 21 6.96609V14.9661C21 15.4965 20.7893 16.0052 20.4142 16.3803C20.0391 16.7554 19.5304 16.9661 19 16.9661H14L9 21.9661V16.9661Z"
      stroke="#637E85"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="svgicon stroke"
    />
  </svg>
);

export const MessagesIconActive = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.5984 6.0001V15.6001C21.5984 16.2366 21.3456 16.8471 20.8955 17.2972C20.4454 17.7472 19.835 18.0001 19.1984 18.0001H13.1984L7.19844 22.8001V18.0001H4.79844C4.16192 18.0001 3.55147 17.7472 3.10138 17.2972C2.65129 16.8471 2.39844 16.2366 2.39844 15.6001V6.0001C2.39844 5.36358 2.65129 4.75313 3.10138 4.30304C3.55147 3.85295 4.16192 3.6001 4.79844 3.6001H19.1984C19.835 3.6001 20.4454 3.85295 20.8955 4.30304C21.3456 4.75313 21.5984 5.36358 21.5984 6.0001ZM8.39844 9.6001H5.99844V12.0001H8.39844V9.6001ZM10.7984 9.6001H13.1984V12.0001H10.7984V9.6001ZM17.9984 9.6001H15.5984V12.0001H17.9984V9.6001Z"
      fill="#1B0ED8"
      className="svgicon-primary fill"
    />
  </svg>
);

export const FeaturesIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.7122 15.4975L10.7217 15.4955L10.7048 15.4885C10.5051 15.4053 10.3179 15.3179 10.1433 15.2264C9.96891 15.1351 9.79026 15.0229 9.60735 14.8899L9.61229 14.8831L9.59629 14.8881L8.87132 15.1131C8.65731 15.1789 8.45198 15.1706 8.25481 15.0885C8.05723 15.0061 7.90093 14.8745 7.78564 14.6934C7.78561 14.6934 7.78558 14.6933 7.78555 14.6933L7.5608 14.3187C7.56078 14.3187 7.56075 14.3186 7.56073 14.3186C7.44552 14.121 7.40446 13.9114 7.43737 13.6893C7.47022 13.4675 7.57688 13.2828 7.75792 13.1347L7.75817 13.1345L8.30817 12.6595L8.31513 12.6675L8.31237 12.6482C8.27911 12.4154 8.2625 12.1993 8.2625 12C8.2625 11.8007 8.27911 11.5846 8.31237 11.3518L8.32292 11.3533L8.30817 11.3405L7.75817 10.8655L7.75817 10.8655L7.75792 10.8653C7.57699 10.7173 7.47026 10.5284 7.43737 10.2982C7.40443 10.0676 7.44558 9.85382 7.5608 9.6563L7.56085 9.6562L7.7607 9.30646C7.8759 9.12554 8.03625 8.99396 8.24214 8.91161C8.44779 8.82935 8.65736 8.82111 8.87132 8.88695L9.59629 9.11194L9.5938 9.11996L9.60735 9.11011C9.79026 8.97708 9.96891 8.86492 10.1433 8.77357C10.3179 8.68209 10.5051 8.59474 10.7048 8.51154L10.7084 8.52026L10.7122 8.50262L10.8622 7.80262C10.9117 7.57186 11.0228 7.38264 11.1956 7.23449C11.3683 7.08646 11.5696 7.0125 11.8 7.0125H12.2C12.4306 7.0125 12.6319 7.08242 12.8046 7.22222C12.9773 7.36197 13.0883 7.54689 13.1378 7.7776C13.1378 7.7776 13.1378 7.77761 13.1378 7.77762L13.2878 8.50253L13.2783 8.50449L13.2952 8.51154C13.4949 8.59474 13.6821 8.68209 13.8567 8.77357C14.0311 8.86492 14.2097 8.97708 14.3926 9.11011L14.3877 9.1169L14.4037 9.11194L15.1287 8.88695C15.3427 8.8211 15.548 8.82938 15.7452 8.91154C15.9428 8.99387 16.0991 9.12547 16.2144 9.30658C16.2144 9.30663 16.2144 9.30667 16.2145 9.30671L16.4392 9.6813C16.4392 9.68131 16.4392 9.68131 16.4392 9.68132C16.5545 9.87891 16.5955 10.0885 16.5626 10.3107C16.5298 10.5325 16.4231 10.7172 16.2421 10.8653L16.2418 10.8655L15.6918 11.3405L15.6849 11.3325L15.6876 11.3518C15.7209 11.5846 15.7375 11.8007 15.7375 12C15.7375 12.1993 15.7209 12.4154 15.6876 12.6482L15.6771 12.6467L15.6918 12.6595L16.2418 13.1345L16.2421 13.1347C16.423 13.2827 16.5297 13.4716 16.5626 13.7018C16.5956 13.9324 16.5544 14.1462 16.4392 14.3437L16.4391 14.3438L16.2395 14.6933C16.2394 14.6934 16.2393 14.6935 16.2393 14.6935C16.1241 14.8745 15.9638 15.006 15.7579 15.0884C15.5522 15.1707 15.3426 15.1789 15.1287 15.1131L14.4037 14.8881L14.4062 14.88L14.3926 14.8899C14.2097 15.0229 14.0311 15.1351 13.8567 15.2264C13.6821 15.3179 13.4949 15.4053 13.2952 15.4885L13.2916 15.4797L13.2878 15.4974L13.1378 16.1974C13.0883 16.4281 12.9772 16.6174 12.8044 16.7655C12.6317 16.9135 12.4304 16.9875 12.2 16.9875H11.8C11.5694 16.9875 11.3681 16.9176 11.1954 16.7778C11.0227 16.638 10.9117 16.4531 10.8622 16.2224C10.8622 16.2224 10.8622 16.2224 10.8622 16.2224L10.7122 15.4975ZM4.9875 19V19.0125H5H19H19.0125V19V5V4.9875H19H5H4.9875V5V19ZM10.5787 13.4213C10.9727 13.8153 11.4467 14.0125 12 14.0125C12.5533 14.0125 13.0273 13.8153 13.4213 13.4213C13.8153 13.0273 14.0125 12.5533 14.0125 12C14.0125 11.4467 13.8153 10.9727 13.4213 10.5787C13.0273 10.1847 12.5533 9.9875 12 9.9875C11.4467 9.9875 10.9727 10.1847 10.5787 10.5787C10.1847 10.9727 9.9875 11.4467 9.9875 12C9.9875 12.5533 10.1847 13.0273 10.5787 13.4213ZM5 20.9875C4.45334 20.9875 3.98568 20.793 3.59634 20.4037C3.207 20.0143 3.0125 19.5467 3.0125 19V5C3.0125 4.45334 3.207 3.98568 3.59634 3.59634C3.98568 3.207 4.45334 3.0125 5 3.0125H19C19.5467 3.0125 20.0143 3.207 20.4037 3.59634C20.793 3.98568 20.9875 4.45334 20.9875 5V19C20.9875 19.5467 20.793 20.0143 20.4037 20.4037C20.0143 20.793 19.5467 20.9875 19 20.9875H5Z"
      fill="#637E85"
      stroke="#637E85"
      strokeWidth="0.025"
    />
  </svg>
);

export const InstrumentLibraryIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 18.75C5 18.1533 5.23705 17.581 5.65901 17.159C6.08097 16.7371 6.65326 16.5 7.25 16.5H19.4"
      stroke="#637E85"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.25 3H19.4V21H7.25C6.65326 21 6.08097 20.7629 5.65901 20.341C5.23705 19.919 5 19.3467 5 18.75V5.25C5 4.65326 5.23705 4.08097 5.65901 3.65901C6.08097 3.23705 6.65326 3 7.25 3V3Z"
      stroke="#637E85"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlatformUsersIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 17.0004C17.4167 17.0004 17.7708 16.8546 18.0625 16.5629C18.3542 16.2712 18.5 15.9171 18.5 15.5004C18.5 15.0837 18.3542 14.7296 18.0625 14.4379C17.7708 14.1462 17.4167 14.0004 17 14.0004C16.5833 14.0004 16.2292 14.1462 15.9375 14.4379C15.6458 14.7296 15.5 15.0837 15.5 15.5004C15.5 15.9171 15.6458 16.2712 15.9375 16.5629C16.2292 16.8546 16.5833 17.0004 17 17.0004ZM17 20.0004C17.5167 20.0004 17.9917 19.8796 18.425 19.6379C18.8583 19.3962 19.2083 19.0754 19.475 18.6754C19.1083 18.4587 18.7167 18.2921 18.3 18.1754C17.8833 18.0587 17.45 18.0004 17 18.0004C16.55 18.0004 16.1167 18.0587 15.7 18.1754C15.2833 18.2921 14.8917 18.4587 14.525 18.6754C14.7917 19.0754 15.1417 19.3962 15.575 19.6379C16.0083 19.8796 16.4833 20.0004 17 20.0004ZM17 22.0004C15.6167 22.0004 14.4375 21.5129 13.4625 20.5379C12.4875 19.5629 12 18.3837 12 17.0004C12 15.6171 12.4875 14.4379 13.4625 13.4629C14.4375 12.4879 15.6167 12.0004 17 12.0004C18.3833 12.0004 19.5625 12.4879 20.5375 13.4629C21.5125 14.4379 22 15.6171 22 17.0004C22 18.3837 21.5125 19.5629 20.5375 20.5379C19.5625 21.5129 18.3833 22.0004 17 22.0004ZM12 21.9254H11.7625C11.6875 21.9254 11.6083 21.9087 11.525 21.8754C9.34167 21.2087 7.54167 19.8587 6.125 17.8254C4.70833 15.7921 4 13.5504 4 11.1004V6.37539C4 5.95872 4.12083 5.58372 4.3625 5.25039C4.60417 4.91706 4.91667 4.67539 5.3 4.52539L11.3 2.27539C11.5333 2.19206 11.7667 2.15039 12 2.15039C12.2333 2.15039 12.4667 2.19206 12.7 2.27539L18.7 4.52539C19.0833 4.67539 19.3958 4.91706 19.6375 5.25039C19.8792 5.58372 20 5.95872 20 6.37539V10.6754C19.6833 10.5421 19.3583 10.4212 19.025 10.3129C18.6917 10.2046 18.35 10.1254 18 10.0754V6.40039L12 4.15039L6 6.40039V11.1004C6 11.8837 6.10417 12.6671 6.3125 13.4504C6.52083 14.2337 6.8125 14.9796 7.1875 15.6879C7.5625 16.3962 8.01667 17.0504 8.55 17.6504C9.08333 18.2504 9.675 18.7504 10.325 19.1504C10.5083 19.6837 10.7417 20.1837 11.025 20.6504C11.3083 21.1171 11.6417 21.5421 12.025 21.9254H12Z"
      fill="#637E85"
    />
  </svg>
);

export const SettingsIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.675 4.317C13.249 2.561 10.751 2.561 10.325 4.317C10.049 5.452 8.749 5.99 7.753 5.382C6.209 4.442 4.443 6.209 5.383 7.752C5.5243 7.98375 5.60889 8.24559 5.62987 8.51621C5.65085 8.78683 5.60764 9.05859 5.50375 9.30935C5.39985 9.56011 5.23822 9.7828 5.032 9.95929C4.82578 10.1358 4.5808 10.2611 4.317 10.325C2.561 10.751 2.561 13.249 4.317 13.675C4.58056 13.7391 4.82529 13.8645 5.03127 14.0409C5.23726 14.2174 5.3987 14.44 5.50247 14.6906C5.60624 14.9412 5.64942 15.2128 5.62848 15.4832C5.60755 15.7537 5.5231 16.0153 5.382 16.247C4.442 17.791 6.209 19.557 7.752 18.617C7.98375 18.4757 8.24559 18.3911 8.51621 18.3701C8.78683 18.3491 9.05859 18.3924 9.30935 18.4963C9.56011 18.6001 9.7828 18.7618 9.95929 18.968C10.1358 19.1742 10.2611 19.4192 10.325 19.683C10.751 21.439 13.249 21.439 13.675 19.683C13.7391 19.4194 13.8645 19.1747 14.0409 18.9687C14.2174 18.7627 14.44 18.6013 14.6906 18.4975C14.9412 18.3938 15.2128 18.3506 15.4832 18.3715C15.7537 18.3924 16.0153 18.4769 16.247 18.618C17.791 19.558 19.557 17.791 18.617 16.248C18.4757 16.0162 18.3911 15.7544 18.3701 15.4838C18.3491 15.2132 18.3924 14.9414 18.4963 14.6907C18.6001 14.4399 18.7618 14.2172 18.968 14.0407C19.1742 13.8642 19.4192 13.7389 19.683 13.675C21.439 13.249 21.439 10.751 19.683 10.325C19.4194 10.2609 19.1747 10.1355 18.9687 9.95905C18.7627 9.78258 18.6013 9.55999 18.4975 9.30938C18.3938 9.05877 18.3506 8.78721 18.3715 8.51677C18.3924 8.24634 18.4769 7.98466 18.618 7.753C19.558 6.209 17.791 4.443 16.248 5.383C16.0162 5.5243 15.7544 5.60889 15.4838 5.62987C15.2132 5.65085 14.9414 5.60764 14.6907 5.50375C14.4399 5.39985 14.2172 5.23822 14.0407 5.032C13.8642 4.82578 13.7389 4.5808 13.675 4.317Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="#637E85"
    />
    <path
      d="M14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="#637E85"
    />
  </svg>
);


export const HelpIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.228 9C8.777 7.835 10.258 7 12 7C14.21 7 16 8.343 16 10C16 11.4 14.722 12.575 12.994 12.907C12.452 13.011 12 13.447 12 14M12 17H12.01M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z"
      stroke="#637E85"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ManualsIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 12H15M9 16H15M17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H12.586C12.8512 3.00006 13.1055 3.10545 13.293 3.293L18.707 8.707C18.8946 8.89449 18.9999 9.1488 19 9.414V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21Z"
      stroke="#637E85"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AllStudiesIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.0279 9.13783L19.0276 9.13778C18.7938 9.08767 18.5475 9.0501 18.2887 9.02506C18.03 9.00002 17.7671 8.9875 17.5 8.9875C17.0659 8.9875 16.64 9.02924 16.2225 9.11274C15.8053 9.19618 15.4048 9.30466 15.0209 9.43819L15.0209 9.43819L15.0205 9.43835C14.7227 9.55413 14.4817 9.54486 14.2946 9.41474C14.1073 9.2844 14.0125 9.07221 14.0125 8.775C14.0125 8.62814 14.0655 8.47639 14.1728 8.31956C14.2802 8.16269 14.3991 8.06062 14.5292 8.01176C15.0119 7.84533 15.4945 7.72052 15.9771 7.63732C16.4597 7.55412 16.9673 7.5125 17.5 7.5125C17.8328 7.5125 18.1614 7.5333 18.4859 7.5749C18.8106 7.61652 19.131 7.67063 19.4473 7.73721C19.5942 7.76987 19.721 7.85148 19.8278 7.98288C19.9344 8.11406 19.9875 8.2613 19.9875 8.425C19.9875 8.70545 19.8969 8.9095 19.7176 9.03989C19.538 9.17051 19.3087 9.20392 19.0279 9.13783ZM19.0279 14.6378L19.0276 14.6378C18.7938 14.5877 18.5475 14.5501 18.2887 14.5251C18.03 14.5 17.7671 14.4875 17.5 14.4875C17.0659 14.4875 16.6402 14.5251 16.2228 14.6002C15.8055 14.6753 15.4049 14.7796 15.0209 14.9132L15.0209 14.9132L15.0205 14.9134C14.7226 15.0292 14.4814 15.024 14.2943 14.902C14.1073 14.78 14.0125 14.5722 14.0125 14.275C14.0125 14.1281 14.0655 13.9764 14.1728 13.8196C14.2802 13.6627 14.3991 13.5606 14.5292 13.5118C15.0119 13.3453 15.4945 13.2205 15.9771 13.1373C16.4597 13.0541 16.9673 13.0125 17.5 13.0125C17.8328 13.0125 18.1614 13.0333 18.4859 13.0749C18.8106 13.1165 19.131 13.1706 19.4473 13.2372C19.5942 13.2699 19.721 13.3515 19.8278 13.4829C19.9344 13.6141 19.9875 13.7613 19.9875 13.925C19.9875 14.2054 19.8969 14.4095 19.7176 14.5399C19.538 14.6705 19.3087 14.7039 19.0279 14.6378ZM19.0279 11.8878L19.0276 11.8878C18.7938 11.8377 18.5475 11.8001 18.2887 11.7751C18.03 11.75 17.7671 11.7375 17.5 11.7375C17.0659 11.7375 16.64 11.7792 16.2225 11.8627C15.8053 11.9462 15.4048 12.0547 15.0209 12.1882L15.0209 12.1882L15.0205 12.1883C14.7227 12.3041 14.4817 12.2949 14.2946 12.1647C14.1073 12.0344 14.0125 11.8222 14.0125 11.525C14.0125 11.3781 14.0655 11.2264 14.1728 11.0696C14.2802 10.9127 14.3991 10.8106 14.5292 10.7618C15.0119 10.5953 15.4945 10.4705 15.9771 10.3873C16.4597 10.3041 16.9673 10.2625 17.5 10.2625C17.8328 10.2625 18.1614 10.2833 18.4859 10.3249C18.8106 10.3665 19.131 10.4206 19.4473 10.4872C19.5942 10.5199 19.721 10.6015 19.8278 10.7329C19.9344 10.8641 19.9875 11.0113 19.9875 11.175C19.9875 11.4554 19.8969 11.6595 19.7176 11.7899C19.538 11.9205 19.3087 11.9539 19.0279 11.8878ZM10.9946 17.0613L11.0125 17.0698V17.05V7.2H11.0247L11.0063 7.18921C10.322 6.78863 9.59593 6.48819 8.82816 6.2879C8.06047 6.08764 7.28441 5.9875 6.5 5.9875C5.89918 5.9875 5.30254 6.04591 4.71008 6.16274C4.11758 6.27957 3.54592 6.45482 2.99512 6.68849L2.9875 6.67054V6.7V16.6V16.6175L3.00405 16.6118C3.5868 16.412 4.16533 16.2622 4.73964 16.1623C5.31391 16.0624 5.9007 16.0125 6.5 16.0125C7.28239 16.0125 8.04393 16.0999 8.78463 16.2747C9.52537 16.4494 10.262 16.7116 10.9946 17.0613ZM12.9875 17.05V17.0698L13.0054 17.0613C13.738 16.7116 14.4746 16.4494 15.2154 16.2747C15.9561 16.0999 16.7176 16.0125 17.5 16.0125C18.0993 16.0125 18.6861 16.0624 19.2604 16.1623C19.8347 16.2622 20.4132 16.412 20.9959 16.6118L21.0125 16.6175V16.6V6.7H21.032L21.0049 6.68849C20.4541 6.45482 19.8824 6.27957 19.2899 6.16274C18.6975 6.04591 18.1008 5.9875 17.5 5.9875C16.7156 5.9875 15.9395 6.08764 15.1718 6.2879C14.4041 6.48819 13.678 6.78863 12.9937 7.18921L12.9875 7.17865V7.2V17.05ZM1.55517 5.21138L1.55518 5.2114L1.55578 5.21108C2.32155 4.81155 3.12059 4.51191 3.95292 4.31215C4.78528 4.11239 5.6343 4.0125 6.5 4.0125C7.46558 4.0125 8.41031 4.13736 9.33424 4.38707C10.2581 4.63677 11.1446 5.01132 11.9937 5.51077L11.987 5.52218L12.0063 5.51077C12.8554 5.01132 13.7419 4.63677 14.6658 4.38707C15.5897 4.13736 16.5344 4.0125 17.5 4.0125C18.3657 4.0125 19.2147 4.11239 20.0471 4.31215C20.8794 4.51191 21.6785 4.81155 22.4442 5.21108L22.4442 5.2111L22.4448 5.21138C22.6259 5.29367 22.7613 5.41686 22.8515 5.58102C22.9422 5.74592 22.9875 5.91885 22.9875 6.1V18.15C22.9875 18.529 22.8272 18.8166 22.5059 19.0144C22.1849 19.2119 21.8521 19.2203 21.5058 19.0389C20.8883 18.7052 20.2417 18.4465 19.5658 18.2629C18.8897 18.0793 18.2011 17.9875 17.5 17.9875C16.7489 17.9875 16.0145 18.0835 15.2968 18.2754C14.5791 18.4674 13.8947 18.7553 13.2438 19.1391C13.0614 19.2386 12.8665 19.3174 12.6591 19.3755C12.452 19.4335 12.2323 19.4625 12 19.4625C11.7677 19.4625 11.548 19.4335 11.3409 19.3755C11.1335 19.3174 10.9386 19.2386 10.7562 19.1391C10.1053 18.7553 9.42094 18.4674 8.70323 18.2754C7.9855 18.0835 7.25108 17.9875 6.5 17.9875C5.79889 17.9875 5.11029 18.0793 4.43422 18.2629C3.75832 18.4465 3.11162 18.7052 2.49413 19.039C2.14789 19.2203 1.81512 19.2119 1.49405 19.0144C1.17277 18.8166 1.0125 18.529 1.0125 18.15V6.1C1.0125 5.91885 1.05776 5.74592 1.14845 5.58102C1.23874 5.41686 1.37414 5.29367 1.55517 5.21138Z"
      fill="#637E85"
      stroke="#637E85"
      strokeWidth="0.025"
    />
  </svg>
);

export const MahaloParticipantIcon = () => (
  <svg
    width="156"
    height="44"
    viewBox="0 0 156 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.14"
      d="M43.0232 21.9557C43.0232 33.756 33.4571 43.322 21.6568 43.322C9.85655 43.322 0.290527 33.756 0.290527 21.9557C0.290527 10.1554 9.85655 0.589355 21.6568 0.589355C33.4571 0.589355 43.0232 10.1554 43.0232 21.9557Z"
      fill="url(#paint0_linear_183_3230)"
    />
    <path
      d="M36.7574 28.5174V14.9488C36.7574 12.8127 35.0562 11.0811 32.9576 11.0811C30.859 11.0811 29.1577 12.8127 29.1577 14.9488V24.1754C29.5166 23.8282 29.9927 23.5399 30.4612 23.7029C30.7111 23.7898 30.9339 23.9581 31.0358 24.2548C31.1969 24.7243 30.9416 25.2199 30.7133 25.6596L29.6612 27.6853C29.6118 27.7805 29.5499 27.8684 29.4772 27.9467C29.272 28.1675 29.1577 28.4599 29.1577 28.7639V29.4561C29.1577 31.0738 30.4461 32.3852 32.0353 32.3852H32.9576C35.0562 32.3852 36.7574 30.6535 36.7574 28.5174Z"
      fill="#C3B8FF"
    />
    <path
      d="M23.0529 28.6482V14.8192C23.0529 12.6862 21.3238 10.957 19.1908 10.957C17.0578 10.957 15.3286 12.6862 15.3286 14.8192V24.2045C15.6933 23.8534 16.1801 23.5606 16.6578 23.728C16.9138 23.8176 17.1412 23.9915 17.2419 24.2982C17.396 24.7672 17.1437 25.2575 16.9153 25.6952L15.8404 27.7554C15.7901 27.8518 15.7271 27.9409 15.6529 28.0204C15.4445 28.2437 15.3286 28.5377 15.3286 28.8431V29.539C15.3286 31.18 16.6589 32.5103 18.2999 32.5103H19.1908C21.3238 32.5103 23.0529 30.7812 23.0529 28.6482Z"
      fill="#C3B8FF"
    />
    <path
      d="M36.3758 19.6808C37.8993 18.1574 40.3599 18.148 41.8718 19.6599C43.3837 21.1718 43.3743 23.6324 41.8508 25.1558L35.512 31.4947C33.9885 33.0182 31.5279 33.0275 30.016 31.5157C28.5041 30.0038 28.5135 27.5431 30.037 26.0197L36.3758 19.6808Z"
      fill="url(#paint1_linear_183_3230)"
    />
    <path
      d="M16.4974 12.1222C18.0031 10.6166 20.4442 10.6166 21.9499 12.1222C23.4555 13.6279 23.4555 16.069 21.9499 17.5746L8.17956 31.3449C6.67391 32.8506 4.23277 32.8506 2.72713 31.3449C1.22148 29.8393 1.22148 27.3982 2.72713 25.8925L16.4974 12.1222Z"
      fill="url(#paint2_linear_183_3230)"
    />
    <path
      d="M30.0892 12.2648C31.6375 10.7165 34.1477 10.7165 35.696 12.2648C37.2442 13.8131 37.2442 16.3233 35.696 17.8716L21.8551 31.7125C20.3068 33.2607 17.7966 33.2607 16.2483 31.7125C14.7 30.1642 14.7 27.654 16.2483 26.1057L30.0892 12.2648Z"
      fill="url(#paint3_linear_183_3230)"
    />
    <path
      opacity="0.14"
      d="M43.0232 22.2296C43.0232 34.0299 33.4571 43.5959 21.6568 43.5959C9.85655 43.5959 0.290527 34.0299 0.290527 22.2296C0.290527 10.4293 9.85655 0.863281 21.6568 0.863281C33.4571 0.863281 43.0232 10.4293 43.0232 22.2296Z"
      fill="url(#paint4_linear_183_3230)"
    />
    <path
      d="M36.7574 28.7914V15.2227C36.7574 13.0866 35.0562 11.355 32.9576 11.355C30.859 11.355 29.1577 13.0866 29.1577 15.2227V24.4493C29.5166 24.1022 29.9927 23.8139 30.4612 23.9768C30.7111 24.0637 30.9339 24.2321 31.0358 24.5287C31.1969 24.9982 30.9416 25.4938 30.7133 25.9335L29.6612 27.9593C29.6118 28.0545 29.5499 28.1424 29.4772 28.2206C29.272 28.4415 29.1577 28.7339 29.1577 29.0378V29.7301C29.1577 31.3477 30.4461 32.6591 32.0353 32.6591H32.9576C35.0562 32.6591 36.7574 30.9274 36.7574 28.7914Z"
      fill="#C3B8FF"
    />
    <path
      d="M23.0524 28.9221V15.0931C23.0524 12.9601 21.3233 11.231 19.1903 11.231C17.0573 11.231 15.3281 12.9601 15.3281 15.0931V24.4784C15.6928 24.1274 16.1796 23.8346 16.6573 24.0019C16.9133 24.0916 17.1407 24.2654 17.2415 24.5722C17.3955 25.0412 17.1432 25.5315 16.9148 25.9691L15.8399 28.0293C15.7897 28.1257 15.7266 28.2149 15.6524 28.2943C15.444 28.5176 15.3281 28.8116 15.3281 29.117V29.8129C15.3281 31.4539 16.6584 32.7842 18.2994 32.7842H19.1903C21.3233 32.7842 23.0524 31.0551 23.0524 28.9221Z"
      fill="#C3B8FF"
    />
    <path
      d="M36.3753 19.9548C37.8988 18.4313 40.3594 18.4219 41.8713 19.9338C43.3832 21.4457 43.3738 23.9063 41.8503 25.4298L35.5115 31.7686C33.988 33.2921 31.5274 33.3015 30.0155 31.7896C28.5036 30.2777 28.513 27.8171 30.0365 26.2936L36.3753 19.9548Z"
      fill="url(#paint5_linear_183_3230)"
    />
    <path
      d="M16.4974 12.3961C18.0031 10.8905 20.4442 10.8905 21.9499 12.3961C23.4555 13.9018 23.4555 16.3429 21.9499 17.8486L8.17956 31.6189C6.67391 33.1245 4.23277 33.1245 2.72713 31.6189C1.22148 30.1132 1.22148 27.6721 2.72713 26.1664L16.4974 12.3961Z"
      fill="url(#paint6_linear_183_3230)"
    />
    <path
      d="M30.0892 12.5387C31.6375 10.9905 34.1477 10.9905 35.696 12.5387C37.2442 14.087 37.2442 16.5972 35.696 18.1455L21.8551 31.9864C20.3068 33.5347 17.7966 33.5347 16.2483 31.9864C14.7 30.4381 14.7 27.9279 16.2483 26.3796L30.0892 12.5387Z"
      fill="url(#paint7_linear_183_3230)"
    />
    <path
      d="M69.1868 11.9141C70.091 11.9141 70.9111 12.0719 71.6471 12.3876C72.4041 12.7033 73.0454 13.1558 73.5711 13.745C74.0968 14.3343 74.5069 15.0394 74.8012 15.8601C75.0956 16.6599 75.2428 17.5648 75.2428 18.575V28.3929H71.6786V19.1117C71.6786 17.8911 71.3842 16.9335 70.7955 16.239C70.2067 15.5445 69.3761 15.1972 68.3037 15.1972C67.2944 15.1972 66.4848 15.5129 65.875 16.1443C65.2652 16.7756 64.9077 17.5754 64.8026 18.5435V18.6382V28.3929H61.2384V19.1117C61.2384 17.8911 60.9335 16.9335 60.3237 16.239C59.7349 15.5445 58.9569 15.1972 57.9896 15.1972C56.8541 15.1972 55.9499 15.576 55.277 16.3337C54.6252 17.0703 54.2993 18.0068 54.2993 19.1433V28.3929H50.7666V12.1982H54.11V14.3448C54.5306 13.6293 55.1088 13.0505 55.8448 12.6086C56.6018 12.1456 57.5796 11.9141 58.7781 11.9141C59.9136 11.9141 60.923 12.1666 61.8061 12.6717C62.6893 13.1768 63.3937 13.9029 63.9194 14.8499C64.4031 14.0081 65.0759 13.3136 65.9381 12.7664C66.8212 12.1982 67.9042 11.9141 69.1868 11.9141Z"
      fill="#212121"
    />
    <path
      d="M85.5469 11.9141C87.6497 11.9141 89.2478 12.4613 90.3413 13.5556C91.4557 14.65 92.013 16.239 92.013 18.3225V28.3929H88.4488V26.9407C87.881 27.4879 87.2292 27.9193 86.4932 28.235C85.7782 28.5507 84.9687 28.7086 84.0645 28.7086C82.4454 28.7086 81.1416 28.2982 80.1533 27.4774C79.165 26.6566 78.6709 25.4886 78.6709 23.9733C78.6709 23.1104 78.8181 22.3843 79.1125 21.795C79.4279 21.1847 79.8484 20.6901 80.3741 20.3113C80.9209 19.9114 81.5517 19.6168 82.2666 19.4274C83.0026 19.238 83.7806 19.1222 84.6007 19.0801L88.4488 18.8592V18.3856C88.4488 17.3333 88.2175 16.5126 87.7548 15.9233C87.3133 15.3129 86.5878 15.0078 85.5785 15.0078C84.5692 15.0078 83.8332 15.2814 83.3706 15.8286C82.908 16.3758 82.6767 17.0177 82.6767 17.7543L79.1125 17.628C79.1125 16.9124 79.2597 16.2179 79.5541 15.5445C79.8484 14.8499 80.269 14.2396 80.8157 13.7135C81.3624 13.1663 82.0353 12.7348 82.8344 12.4192C83.6334 12.0824 84.5376 11.9141 85.5469 11.9141ZM85.1054 21.8266C84.2643 21.8687 83.5703 22.0476 83.0236 22.3633C82.4979 22.6579 82.2351 23.1735 82.2351 23.9101C82.2351 24.5836 82.4559 25.0571 82.8975 25.3307C83.3601 25.6043 83.9488 25.7411 84.6638 25.7411C85.7993 25.7411 86.714 25.457 87.4079 24.8888C88.1228 24.3205 88.4803 23.4156 88.4803 22.1739V21.6056L85.1054 21.8266Z"
      fill="#212121"
    />
    <path
      d="M100.296 14.0284C100.675 13.4601 101.243 12.9656 102 12.5446C102.757 12.1237 103.703 11.9133 104.838 11.9133C105.764 11.9133 106.605 12.0711 107.362 12.3868C108.14 12.6814 108.802 13.1234 109.349 13.7127C109.916 14.2809 110.358 14.986 110.673 15.8278C110.989 16.6486 111.147 17.5851 111.147 18.6374V28.3921H107.582V19.1109C107.582 17.8903 107.256 16.9327 106.605 16.2382C105.974 15.5437 105.122 15.1964 104.05 15.1964C102.914 15.1964 102 15.5752 101.306 16.3329C100.633 17.0695 100.296 18.006 100.296 19.1425V28.3921H96.7637V3.86328H100.296V14.0284Z"
      fill="#212121"
    />
    <path
      d="M121.029 11.9141C123.132 11.9141 124.73 12.4613 125.823 13.5556C126.938 14.65 127.495 16.239 127.495 18.3225V28.3929H123.931V26.9407C123.363 27.4879 122.711 27.9193 121.975 28.235C121.26 28.5507 120.451 28.7086 119.546 28.7086C117.927 28.7086 116.624 28.2982 115.635 27.4774C114.647 26.6566 114.153 25.4886 114.153 23.9733C114.153 23.1104 114.3 22.3843 114.594 21.795C114.91 21.1847 115.33 20.6901 115.856 20.3113C116.403 19.9114 117.034 19.6168 117.749 19.4274C118.485 19.238 119.263 19.1222 120.083 19.0801L123.931 18.8592V18.3856C123.931 17.3333 123.699 16.5126 123.237 15.9233C122.795 15.3129 122.07 15.0078 121.06 15.0078C120.051 15.0078 119.315 15.2814 118.853 15.8286C118.39 16.3758 118.159 17.0177 118.159 17.7543L114.594 17.628C114.594 16.9124 114.742 16.2179 115.036 15.5445C115.33 14.8499 115.751 14.2396 116.298 13.7135C116.844 13.1663 117.517 12.7348 118.316 12.4192C119.115 12.0824 120.02 11.9141 121.029 11.9141ZM120.587 21.8266C119.746 21.8687 119.052 22.0476 118.506 22.3633C117.98 22.6579 117.717 23.1735 117.717 23.9101C117.717 24.5836 117.938 25.0571 118.379 25.3307C118.842 25.6043 119.431 25.7411 120.146 25.7411C121.281 25.7411 122.196 25.457 122.89 24.8888C123.605 24.3205 123.962 23.4156 123.962 22.1739V21.6056L120.587 21.8266Z"
      fill="#212121"
    />
    <path d="M132.25 28.3921V3.86328H135.783V28.3921H132.25Z" fill="#212121" />
    <path
      d="M147.578 11.9141C148.777 11.9141 149.891 12.114 150.922 12.5139C151.952 12.8927 152.835 13.4504 153.571 14.187C154.328 14.9026 154.917 15.7865 155.337 16.8388C155.779 17.87 156 19.0275 156 20.3113C156 21.5951 155.779 22.7526 155.337 23.7839C154.917 24.8151 154.328 25.699 153.571 26.4356C152.835 27.1512 151.952 27.7089 150.922 28.1088C149.891 28.5086 148.777 28.7086 147.578 28.7086C146.38 28.7086 145.265 28.5086 144.235 28.1088C143.204 27.7089 142.311 27.1512 141.554 26.4356C140.797 25.699 140.197 24.8151 139.756 23.7839C139.335 22.7526 139.125 21.5951 139.125 20.3113C139.125 19.0275 139.335 17.87 139.756 16.8388C140.197 15.7865 140.797 14.9026 141.554 14.187C142.311 13.4504 143.204 12.8927 144.235 12.5139C145.265 12.114 146.38 11.9141 147.578 11.9141ZM147.578 14.9446C146.169 14.9446 145.002 15.4182 144.077 16.3652C143.173 17.2912 142.721 18.6066 142.721 20.3113C142.721 21.995 143.173 23.3103 144.077 24.2574C145.002 25.1834 146.169 25.6464 147.578 25.6464C148.272 25.6464 148.913 25.5307 149.502 25.2992C150.091 25.0466 150.606 24.6994 151.048 24.2574C151.489 23.7944 151.826 23.2367 152.057 22.5843C152.309 21.9108 152.436 21.1531 152.436 20.3113C152.436 19.4695 152.309 18.7224 152.057 18.0699C151.826 17.3965 151.489 16.8282 151.048 16.3652C150.606 15.9022 150.091 15.555 149.502 15.3235C148.913 15.0709 148.272 14.9446 147.578 14.9446Z"
      fill="#212121"
    />
    <path
      d="M147.003 34.1134V33.1519H152.733V34.1134H150.423V40.5553H149.31V34.1134H147.003Z"
      fill="url(#paint8_linear_183_3230)"
    />
    <path
      d="M144.978 33.1519V40.5553H143.952L140.189 35.1256H140.12V40.5553H139.003V33.1519H140.037L143.804 38.5888H143.872V33.1519H144.978Z"
      fill="url(#paint9_linear_183_3230)"
    />
    <path
      d="M131.19 40.5553H130.004L132.669 33.1519H133.959L136.623 40.5553H135.438L133.345 34.4966H133.287L131.19 40.5553ZM131.389 37.6561H135.235V38.596H131.389V37.6561Z"
      fill="url(#paint10_linear_183_3230)"
    />
    <path
      d="M124.001 40.5553V33.1519H126.64C127.216 33.1519 127.694 33.2567 128.072 33.4664C128.45 33.676 128.733 33.9628 128.921 34.3267C129.109 34.6882 129.203 35.0955 129.203 35.5486C129.203 36.0041 129.108 36.4138 128.918 36.7777C128.73 37.1392 128.445 37.426 128.065 37.638C127.686 37.8477 127.21 37.9525 126.637 37.9525H124.822V37.0054H126.536C126.899 37.0054 127.195 36.9428 127.421 36.8174C127.648 36.6897 127.814 36.5162 127.92 36.2969C128.026 36.0776 128.079 35.8281 128.079 35.5486C128.079 35.269 128.026 35.0208 127.92 34.8039C127.814 34.587 127.647 34.4171 127.418 34.2942C127.191 34.1713 126.892 34.1098 126.521 34.1098H125.118V40.5553H124.001Z"
      fill="url(#paint11_linear_183_3230)"
    />
    <path
      d="M78.001 40.5553V33.1519H80.6399C81.2159 33.1519 81.6931 33.2567 82.0714 33.4664C82.4498 33.676 82.733 33.9628 82.921 34.3267C83.1089 34.6882 83.2029 35.0955 83.2029 35.5486C83.2029 36.0041 83.1077 36.4138 82.9174 36.7777C82.7294 37.1392 82.445 37.426 82.0642 37.638C81.6858 37.8477 81.2099 37.9525 80.6363 37.9525H78.8216V37.0054H80.5351C80.899 37.0054 81.1942 36.9428 81.4207 36.8174C81.6473 36.6897 81.8136 36.5162 81.9196 36.2969C82.0257 36.0776 82.0787 35.8281 82.0787 35.5486C82.0787 35.269 82.0257 35.0208 81.9196 34.8039C81.8136 34.587 81.6461 34.4171 81.4171 34.2942C81.1906 34.1713 80.8918 34.1098 80.5206 34.1098H79.118V40.5553H78.001Z"
      fill="url(#paint12_linear_183_3230)"
    />
    <path
      d="M121.121 33.1519V40.5553H120.004V33.1519H121.121Z"
      fill="url(#paint13_linear_183_3230)"
    />
    <path
      d="M117.386 35.5596H116.258C116.215 35.3186 116.134 35.1065 116.016 34.9233C115.898 34.7402 115.753 34.5847 115.582 34.457C115.411 34.3293 115.22 34.2329 115.008 34.1678C114.798 34.1027 114.575 34.0702 114.339 34.0702C113.912 34.0702 113.53 34.1775 113.193 34.3919C112.858 34.6064 112.593 34.9209 112.398 35.3354C112.205 35.75 112.108 36.2561 112.108 36.8537C112.108 37.4562 112.205 37.9647 112.398 38.3793C112.593 38.7938 112.859 39.1071 113.196 39.3192C113.534 39.5312 113.913 39.6373 114.335 39.6373C114.569 39.6373 114.791 39.6059 115 39.5433C115.212 39.4782 115.404 39.383 115.575 39.2577C115.746 39.1324 115.891 38.9793 116.009 38.7986C116.129 38.6154 116.213 38.4058 116.258 38.1696L117.386 38.1732C117.326 38.5371 117.209 38.8721 117.036 39.1782C116.864 39.4818 116.644 39.7445 116.374 39.9662C116.107 40.1855 115.8 40.3555 115.456 40.476C115.111 40.5964 114.735 40.6567 114.328 40.6567C113.687 40.6567 113.116 40.5049 112.614 40.2012C112.113 39.8951 111.718 39.4577 111.429 38.889C111.142 38.3202 110.999 37.6418 110.999 36.8537C110.999 36.0633 111.143 35.3849 111.432 34.8185C111.722 34.2497 112.117 33.8135 112.618 33.5099C113.119 33.2038 113.689 33.0508 114.328 33.0508C114.721 33.0508 115.087 33.1074 115.427 33.2207C115.769 33.3315 116.076 33.4954 116.349 33.7123C116.621 33.9268 116.846 34.1895 117.025 34.5004C117.203 34.8089 117.324 35.1619 117.386 35.5596Z"
      fill="url(#paint14_linear_183_3230)"
    />
    <path
      d="M109.12 33.1519V40.5553H108.003V33.1519H109.12Z"
      fill="url(#paint15_linear_183_3230)"
    />
    <path
      d="M100.004 34.1134V33.1519H105.734V34.1134H103.424V40.5553H102.31V34.1134H100.004Z"
      fill="url(#paint16_linear_183_3230)"
    />
    <path
      d="M93.0024 40.5553V33.1519H95.6414C96.215 33.1519 96.6909 33.2507 97.0693 33.4483C97.4501 33.6459 97.7344 33.9194 97.9224 34.2689C98.1104 34.6159 98.2044 35.0172 98.2044 35.4727C98.2044 35.9258 98.1092 36.3246 97.9188 36.6692C97.7308 37.0115 97.4465 37.2778 97.0657 37.4681C96.6873 37.6585 96.2113 37.7537 95.6378 37.7537H93.6387V36.7921H95.5365C95.898 36.7921 96.1921 36.7403 96.4186 36.6367C96.6475 36.5331 96.815 36.3824 96.9211 36.1848C97.0271 35.9872 97.0801 35.7498 97.0801 35.4727C97.0801 35.1931 97.0259 34.9509 96.9175 34.7461C96.8114 34.5412 96.6439 34.3846 96.415 34.2761C96.1884 34.1653 95.8908 34.1098 95.5221 34.1098H94.1195V40.5553H93.0024ZM96.6572 37.2151L98.4864 40.5553H97.2139L95.4209 37.2151H96.6572Z"
      fill="url(#paint17_linear_183_3230)"
    />
    <path
      d="M85.1896 40.4543H84.0039L86.6681 33.0508H87.9587L90.6229 40.4543H89.4372L87.3441 34.3956H87.2863L85.1896 40.4543ZM85.3884 37.555H89.2348V38.4949H85.3884V37.555Z"
      fill="url(#paint18_linear_183_3230)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_183_3230"
        x1="7.8698"
        y1="38.7023"
        x2="38.1147"
        y2="8.38518"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F745D1" />
        <stop offset="0.481131" stop-color="#B405EC" />
        <stop offset="1" stop-color="#2768C1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_183_3230"
        x1="41.1916"
        y1="19.0775"
        x2="29.6176"
        y2="31.1331"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F84AC9" />
        <stop offset="0.499374" stop-color="#F030EA" />
        <stop offset="1" stop-color="#BF2FEB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_183_3230"
        x1="21.2419"
        y1="11.5729"
        x2="2.73383"
        y2="31.3512"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1500D9" />
        <stop offset="0.499374" stop-color="#294FCB" />
        <stop offset="1" stop-color="#2669BF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_183_3230"
        x1="34.7523"
        y1="12.3746"
        x2="16.8708"
        y2="31.0589"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B800EC" />
        <stop offset="0.456979" stop-color="#8F2EE6" />
        <stop offset="1" stop-color="#472CDA" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_183_3230"
        x1="7.8698"
        y1="38.9762"
        x2="38.1147"
        y2="8.6591"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F745D1" />
        <stop offset="0.481131" stop-color="#B405EC" />
        <stop offset="1" stop-color="#2768C1" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_183_3230"
        x1="41.1912"
        y1="19.3515"
        x2="29.6171"
        y2="31.4071"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F84AC9" />
        <stop offset="0.499374" stop-color="#F030EA" />
        <stop offset="1" stop-color="#BF2FEB" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_183_3230"
        x1="21.2419"
        y1="11.8468"
        x2="2.73383"
        y2="31.6251"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1500D9" />
        <stop offset="0.499374" stop-color="#294FCB" />
        <stop offset="1" stop-color="#2669BF" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_183_3230"
        x1="34.7523"
        y1="12.6485"
        x2="16.8708"
        y2="31.3328"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B800EC" />
        <stop offset="0.456979" stop-color="#8F2EE6" />
        <stop offset="1" stop-color="#472CDA" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_183_3230"
        x1="136.762"
        y1="36.8468"
        x2="171.835"
        y2="36.8468"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2765C2" />
        <stop offset="1" stop-color="#190DD7" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_183_3230"
        x1="128.323"
        y1="36.8468"
        x2="164.9"
        y2="36.8468"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2765C2" />
        <stop offset="1" stop-color="#190DD7" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_183_3230"
        x1="118.174"
        y1="36.8468"
        x2="158.69"
        y2="36.8468"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2765C2" />
        <stop offset="1" stop-color="#190DD7" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_183_3230"
        x1="114.704"
        y1="36.8468"
        x2="146.546"
        y2="36.8468"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2765C2" />
        <stop offset="1" stop-color="#190DD7" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_183_3230"
        x1="68.7034"
        y1="36.8468"
        x2="100.545"
        y2="36.8468"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2765C2" />
        <stop offset="1" stop-color="#190DD7" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_183_3230"
        x1="118.007"
        y1="36.8468"
        x2="124.845"
        y2="36.8468"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2765C2" />
        <stop offset="1" stop-color="#190DD7" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_183_3230"
        x1="99.5817"
        y1="36.8468"
        x2="138.681"
        y2="36.8468"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2765C2" />
        <stop offset="1" stop-color="#190DD7" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_183_3230"
        x1="106.006"
        y1="36.8468"
        x2="112.844"
        y2="36.8468"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2765C2" />
        <stop offset="1" stop-color="#190DD7" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_183_3230"
        x1="89.763"
        y1="36.8468"
        x2="124.835"
        y2="36.8468"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2765C2" />
        <stop offset="1" stop-color="#190DD7" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_183_3230"
        x1="83.2009"
        y1="36.8468"
        x2="116.769"
        y2="36.8468"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2765C2" />
        <stop offset="1" stop-color="#190DD7" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_183_3230"
        x1="72.1735"
        y1="36.7457"
        x2="112.689"
        y2="36.7457"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2765C2" />
        <stop offset="1" stop-color="#190DD7" />
      </linearGradient>
    </defs>
  </svg>
);

export const CircleSmallLogo = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.14"
      d="M19.2857 10C19.2857 15.5228 14.9972 20 9.70704 20C4.41691 20 0.128418 15.5228 0.128418 10C0.128418 4.47715 4.41691 0 9.70704 0C14.9972 0 19.2857 4.47715 19.2857 10Z"
      fill="url(#paint0_linear_183_27844)"
    />
    <path
      d="M16.4778 13.0713V6.72083C16.4778 5.72109 15.7151 4.91064 14.7743 4.91064C13.8335 4.91064 13.0708 5.72109 13.0708 6.72083V11.0391C13.2317 10.8767 13.4451 10.7417 13.6552 10.818C13.7672 10.8587 13.8671 10.9375 13.9127 11.0763C13.985 11.2961 13.8705 11.528 13.7682 11.7338L13.2965 12.6819C13.2744 12.7264 13.2466 12.7676 13.214 12.8042C13.1221 12.9076 13.0708 13.0444 13.0708 13.1867V13.5107C13.0708 14.2678 13.6484 14.8815 14.3609 14.8815H14.7743C15.7151 14.8815 16.4778 14.0711 16.4778 13.0713Z"
      fill="#C3B8FF"
    />
    <path
      d="M10.3359 13.1325V6.66013C10.3359 5.66182 9.5607 4.85254 8.60446 4.85254C7.64823 4.85254 6.87305 5.66182 6.87305 6.66012V11.0527C7.03652 10.8884 7.25476 10.7514 7.46893 10.8297C7.58368 10.8716 7.68563 10.953 7.7308 11.0966C7.79988 11.3161 7.68675 11.5455 7.58438 11.7504L7.1025 12.7146C7.07996 12.7597 7.05168 12.8014 7.01843 12.8386C6.925 12.9431 6.87305 13.0808 6.87305 13.2237V13.5494C6.87305 14.3174 7.46942 14.94 8.20509 14.94H8.60446C9.5607 14.94 10.3359 14.1308 10.3359 13.1325Z"
      fill="#C3B8FF"
    />
    <path
      d="M16.3132 8.93508C16.9961 8.22206 18.0993 8.21767 18.777 8.92527C19.4548 9.63287 19.4506 10.7845 18.7676 11.4975L15.9259 14.4643C15.2429 15.1773 14.1398 15.1817 13.462 14.4741C12.7843 13.7665 12.7885 12.6148 13.4714 11.9018L16.3132 8.93508Z"
      fill="url(#paint1_linear_183_27844)"
    />
    <path
      d="M7.3955 5.39801C8.07049 4.69333 9.16486 4.69333 9.83985 5.39801C10.5148 6.10269 10.5148 7.24521 9.83985 7.94989L3.66657 14.3948C2.99158 15.0994 1.89721 15.0994 1.22222 14.3948C0.547229 13.6901 0.54723 12.5476 1.22222 11.8429L7.3955 5.39801Z"
      fill="url(#paint2_linear_183_27844)"
    />
    <path
      d="M13.4937 5.46391C14.1878 4.73928 15.3132 4.73928 16.0073 5.46391C16.7014 6.18854 16.7014 7.3634 16.0073 8.08803L9.80233 14.5659C9.10823 15.2906 7.98288 15.2906 7.28879 14.5659C6.59469 13.8413 6.59469 12.6664 7.28879 11.9418L13.4937 5.46391Z"
      fill="url(#paint3_linear_183_27844)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_183_27844"
        x1="3.52624"
        y1="17.8378"
        x2="17.67"
        y2="4.25775"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F745D1" />
        <stop offset="0.481131" stop-color="#B405EC" />
        <stop offset="1" stop-color="#2768C1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_183_27844"
        x1="18.4721"
        y1="8.65272"
        x2="13.0507"
        y2="14.0618"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F84AC9" />
        <stop offset="0.499374" stop-color="#F030EA" />
        <stop offset="1" stop-color="#BF2FEB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_183_27844"
        x1="9.52248"
        y1="5.1409"
        x2="0.843482"
        y2="14.0247"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1500D9" />
        <stop offset="0.499374" stop-color="#294FCB" />
        <stop offset="1" stop-color="#2669BF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_183_27844"
        x1="15.5842"
        y1="5.5153"
        x2="7.20715"
        y2="13.8996"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B800EC" />
        <stop offset="0.456979" stop-color="#8F2EE6" />
        <stop offset="1" stop-color="#472CDA" />
      </linearGradient>
    </defs>
  </svg>
);

export const QuestionnaireInactiveIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.25 2.29688H15.75C15.7963 2.29684 15.8425 2.30155 15.8877 2.31055L16.0195 2.35059C16.062 2.36817 16.1026 2.38967 16.1406 2.41504L16.2471 2.50293L19.9971 6.25293C20.0298 6.28566 20.0594 6.32107 20.085 6.35938L20.1494 6.48047C20.1847 6.56583 20.2032 6.65764 20.2031 6.75V17.25C20.2031 17.5872 20.0859 17.9123 19.874 18.1709L19.7773 18.2773C19.5048 18.5499 19.1354 18.7031 18.75 18.7031H17.2031V20.25C17.2031 20.5872 17.0859 20.9123 16.874 21.1709L16.7773 21.2773C16.5048 21.5499 16.1354 21.7031 15.75 21.7031H5.25C4.91279 21.7031 4.58768 21.5859 4.3291 21.374L4.22266 21.2773C3.95014 21.0048 3.79688 20.6354 3.79688 20.25V6.75C3.79688 6.41279 3.91411 6.08768 4.12598 5.8291L4.22266 5.72266C4.49517 5.45014 4.86461 5.29688 5.25 5.29688H6.79688V3.75C6.79688 3.41279 6.91411 3.08768 7.12598 2.8291L7.22266 2.72266C7.49517 2.45014 7.86461 2.29688 8.25 2.29688ZM8.25 16.5469H12.75C12.9365 16.5469 13.1152 16.6211 13.2471 16.7529C13.3789 16.8848 13.4531 17.0635 13.4531 17.25C13.4531 17.4365 13.3789 17.6152 13.2471 17.7471C13.1152 17.8789 12.9365 17.9531 12.75 17.9531H8.25C8.11026 17.9531 7.97496 17.9113 7.86035 17.835L7.75293 17.7471C7.62107 17.6152 7.54688 17.4365 7.54688 17.25C7.54688 17.1103 7.5887 16.975 7.66504 16.8604L7.75293 16.7529C7.88479 16.6211 8.06352 16.5469 8.25 16.5469ZM8.25 13.5469H12.75C12.9365 13.5469 13.1152 13.6211 13.2471 13.7529C13.3789 13.8848 13.4531 14.0635 13.4531 14.25C13.4531 14.4365 13.3789 14.6152 13.2471 14.7471C13.1152 14.8789 12.9365 14.9531 12.75 14.9531H8.25C8.11026 14.9531 7.97496 14.9113 7.86035 14.835L7.75293 14.7471C7.62107 14.6152 7.54688 14.4365 7.54688 14.25C7.54688 14.1103 7.5887 13.975 7.66504 13.8604L7.75293 13.7529C7.88479 13.6211 8.06352 13.5469 8.25 13.5469ZM15.7969 10.041L12.459 6.70312H5.20312V20.2969H15.7969V10.041ZM18.7969 7.04102L15.459 3.70312H8.20312V5.29688H12.75C12.8424 5.2968 12.9342 5.3153 13.0195 5.35059C13.062 5.36817 13.1026 5.38967 13.1406 5.41504L13.2471 5.50293L16.9971 9.25293C17.0298 9.28566 17.0594 9.32107 17.085 9.35938L17.1494 9.48047C17.1847 9.56582 17.2032 9.65764 17.2031 9.75V17.2969H18.7969V7.04102Z"
      fill="#6B7280"
      stroke="#6B7280"
      strokeWidth="0.09375"
    />
  </svg>
);

export const QuestionnaireActiveIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M8.25 2.29688H15.75C15.7963 2.29684 15.8425 2.30155 15.8877 2.31055L16.0195 2.35059C16.062 2.36817 16.1026 2.38967 16.1406 2.41504L16.2471 2.50293L19.9971 6.25293C20.0298 6.28566 20.0594 6.32107 20.085 6.35938L20.1494 6.48047C20.1847 6.56583 20.2032 6.65764 20.2031 6.75V17.25C20.2031 17.5872 20.0859 17.9123 19.874 18.1709L19.7773 18.2773C19.5048 18.5499 19.1354 18.7031 18.75 18.7031H17.2031V20.25C17.2031 20.5872 17.0859 20.9123 16.874 21.1709L16.7773 21.2773C16.5048 21.5499 16.1354 21.7031 15.75 21.7031H5.25C4.91279 21.7031 4.58768 21.5859 4.3291 21.374L4.22266 21.2773C3.95014 21.0048 3.79688 20.6354 3.79688 20.25V6.75C3.79688 6.41279 3.91411 6.08768 4.12598 5.8291L4.22266 5.72266C4.49517 5.45014 4.86461 5.29688 5.25 5.29688H6.79688V3.75C6.79688 3.41279 6.91411 3.08768 7.12598 2.8291L7.22266 2.72266C7.49517 2.45014 7.86461 2.29688 8.25 2.29688ZM8.25 16.4531C8.06507 16.4531 7.88692 16.5176 7.74512 16.6338L7.68652 16.6865C7.53708 16.836 7.45312 17.0387 7.45312 17.25C7.45312 17.4349 7.5176 17.6131 7.63379 17.7549L7.68652 17.8135C7.83597 17.9629 8.03866 18.0469 8.25 18.0469H12.75C12.9613 18.0469 13.164 17.9629 13.3135 17.8135C13.4629 17.664 13.5469 17.4613 13.5469 17.25C13.5469 17.0387 13.4629 16.836 13.3135 16.6865C13.164 16.5371 12.9613 16.4531 12.75 16.4531H8.25ZM8.25 13.4531C8.06507 13.4531 7.88692 13.5176 7.74512 13.6338L7.68652 13.6865C7.53708 13.836 7.45312 14.0387 7.45312 14.25C7.45312 14.4349 7.5176 14.6131 7.63379 14.7549L7.68652 14.8135C7.83597 14.9629 8.03866 15.0469 8.25 15.0469H12.75C12.9613 15.0469 13.164 14.9629 13.3135 14.8135C13.4629 14.664 13.5469 14.4613 13.5469 14.25C13.5469 14.0387 13.4629 13.836 13.3135 13.6865C13.164 13.5371 12.9613 13.4531 12.75 13.4531H8.25ZM18.7969 7.04102L15.459 3.70312H8.20312V5.29688H12.75C12.8424 5.2968 12.9342 5.3153 13.0195 5.35059C13.062 5.36817 13.1026 5.38967 13.1406 5.41504L13.2471 5.50293L16.9971 9.25293C17.0298 9.28566 17.0594 9.32107 17.085 9.35938L17.1494 9.48047C17.1847 9.56582 17.2032 9.65764 17.2031 9.75V17.2969H18.7969V7.04102Z"
      fill="#7E3AF2"
      stroke="#7E3AF2"
      strokeWidth="0.09375"
    />
  </svg>
);

export const EConsentInactiveIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.25 10.5C17.25 10.6989 17.171 10.8897 17.0303 11.0303C16.8897 11.171 16.6989 11.25 16.5 11.25H10.5C10.3011 11.25 10.1103 11.171 9.96967 11.0303C9.82902 10.8897 9.75 10.6989 9.75 10.5C9.75 10.3011 9.82902 10.1103 9.96967 9.96967C10.1103 9.82902 10.3011 9.75 10.5 9.75H16.5C16.6989 9.75 16.8897 9.82902 17.0303 9.96967C17.171 10.1103 17.25 10.3011 17.25 10.5ZM16.5 12.75H10.5C10.3011 12.75 10.1103 12.829 9.96967 12.9697C9.82902 13.1103 9.75 13.3011 9.75 13.5C9.75 13.6989 9.82902 13.8897 9.96967 14.0303C10.1103 14.171 10.3011 14.25 10.5 14.25H16.5C16.6989 14.25 16.8897 14.171 17.0303 14.0303C17.171 13.8897 17.25 13.6989 17.25 13.5C17.25 13.3011 17.171 13.1103 17.0303 12.9697C16.8897 12.829 16.6989 12.75 16.5 12.75ZM21 4.5V19.5C21 19.8978 20.842 20.2794 20.5607 20.5607C20.2794 20.842 19.8978 21 19.5 21H4.5C4.10218 21 3.72064 20.842 3.43934 20.5607C3.15804 20.2794 3 19.8978 3 19.5V4.5C3 4.10218 3.15804 3.72064 3.43934 3.43934C3.72064 3.15804 4.10218 3 4.5 3H19.5C19.8978 3 20.2794 3.15804 20.5607 3.43934C20.842 3.72064 21 4.10218 21 4.5ZM4.5 19.5H6.75V4.5H4.5V19.5ZM19.5 19.5V4.5H8.25V19.5H19.5Z"
      fill="#6B7280"
    />
  </svg>
);

export const EConsentActiveIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M4.5 3.0625H19.5C19.8335 3.0625 20.1554 3.17816 20.4111 3.3877L20.5166 3.4834C20.7862 3.75298 20.9375 4.11875 20.9375 4.5V19.5C20.9375 19.8335 20.8218 20.1554 20.6123 20.4111L20.5166 20.5166C20.247 20.7862 19.8812 20.9375 19.5 20.9375H4.5C4.16645 20.9375 3.84465 20.8218 3.58887 20.6123L3.4834 20.5166C3.21382 20.247 3.0625 19.8812 3.0625 19.5V4.5L3.06934 4.3584C3.09726 4.0762 3.208 3.80823 3.3877 3.58887L3.4834 3.4834C3.75298 3.21381 4.11875 3.0625 4.5 3.0625ZM4.4375 19.5625H7.5625V4.4375H4.4375V19.5625ZM10.5 12.6875C10.3116 12.6875 10.1299 12.7528 9.98535 12.8711L9.92578 12.9258C9.77341 13.0782 9.6875 13.2845 9.6875 13.5C9.6875 13.6884 9.75282 13.8701 9.87109 14.0146L9.92578 14.0742C10.0782 14.2266 10.2845 14.3125 10.5 14.3125H16.5C16.7155 14.3125 16.9218 14.2266 17.0742 14.0742C17.2266 13.9218 17.3125 13.7155 17.3125 13.5C17.3125 13.2845 17.2266 13.0782 17.0742 12.9258C16.9218 12.7734 16.7155 12.6875 16.5 12.6875H10.5ZM10.5 9.6875C10.3116 9.6875 10.1299 9.75282 9.98535 9.87109L9.92578 9.92578C9.77341 10.0782 9.6875 10.2845 9.6875 10.5C9.6875 10.6884 9.75282 10.8701 9.87109 11.0146L9.92578 11.0742C10.0782 11.2266 10.2845 11.3125 10.5 11.3125H16.5C16.6884 11.3125 16.8701 11.2472 17.0146 11.1289L17.0742 11.0742C17.2266 10.9218 17.3125 10.7155 17.3125 10.5C17.3125 10.3116 17.2472 10.1299 17.1289 9.98535L17.0742 9.92578C16.9218 9.77341 16.7155 9.6875 16.5 9.6875H10.5Z"
      fill="#7E3AF2"
      stroke="#7E3AF2"
      strokeWidth="0.125"
    />
  </svg>
);

export const HomeActiveIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M5.25 12.8125H9.75C10.0835 12.8125 10.4054 12.9282 10.6611 13.1377L10.7666 13.2334C11.0362 13.503 11.1875 13.8688 11.1875 14.25V18.75C11.1875 19.0835 11.0718 19.4054 10.8623 19.6611L10.7666 19.7666C10.497 20.0362 10.1312 20.1875 9.75 20.1875H5.25C4.91645 20.1875 4.59465 20.0718 4.33887 19.8623L4.2334 19.7666C3.96381 19.497 3.8125 19.1312 3.8125 18.75V14.25C3.8125 13.9165 3.92816 13.5946 4.1377 13.3389L4.2334 13.2334C4.50298 12.9638 4.86875 12.8125 5.25 12.8125ZM14.25 12.8125H18.75C19.0835 12.8125 19.4054 12.9282 19.6611 13.1377L19.7666 13.2334C20.0362 13.503 20.1875 13.8688 20.1875 14.25V18.75C20.1875 19.0835 20.0718 19.4054 19.8623 19.6611L19.7666 19.7666C19.497 20.0362 19.1312 20.1875 18.75 20.1875H14.25C13.9165 20.1875 13.5946 20.0718 13.3389 19.8623L13.2334 19.7666C12.9638 19.497 12.8125 19.1312 12.8125 18.75V14.25C12.8125 13.9165 12.9282 13.5946 13.1377 13.3389L13.2334 13.2334C13.503 12.9638 13.8688 12.8125 14.25 12.8125ZM5.25 3.8125H9.75C10.0835 3.8125 10.4054 3.92816 10.6611 4.1377L10.7666 4.2334C11.0362 4.50298 11.1875 4.86875 11.1875 5.25V9.75C11.1875 10.1312 11.0362 10.497 10.7666 10.7666C10.497 11.0362 10.1312 11.1875 9.75 11.1875H5.25C4.91645 11.1875 4.59465 11.0718 4.33887 10.8623L4.2334 10.7666C3.96381 10.497 3.8125 10.1312 3.8125 9.75V5.25C3.8125 4.91645 3.92816 4.59465 4.1377 4.33887L4.2334 4.2334C4.50298 3.96381 4.86875 3.8125 5.25 3.8125ZM14.25 3.8125H18.75C19.0835 3.8125 19.4054 3.92816 19.6611 4.1377L19.7666 4.2334C20.0362 4.50298 20.1875 4.86875 20.1875 5.25V9.75C20.1875 10.0835 20.0718 10.4054 19.8623 10.6611L19.7666 10.7666C19.497 11.0362 19.1312 11.1875 18.75 11.1875H14.25C13.9165 11.1875 13.5946 11.0718 13.3389 10.8623L13.2334 10.7666C12.9638 10.497 12.8125 10.1312 12.8125 9.75V5.25C12.8125 4.91645 12.9282 4.59465 13.1377 4.33887L13.2334 4.2334C13.503 3.96381 13.8688 3.8125 14.25 3.8125Z"
      fill="#7E3AF2"
      stroke="#7E3AF2"
      strokeWidth="0.125"
    />
  </svg>
);

export const HomeInactiveIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M5.25 12.8125H9.75C10.0835 12.8125 10.4054 12.9282 10.6611 13.1377L10.7666 13.2334C11.0362 13.503 11.1875 13.8688 11.1875 14.25V18.75C11.1875 19.0835 11.0718 19.4054 10.8623 19.6611L10.7666 19.7666C10.497 20.0362 10.1312 20.1875 9.75 20.1875H5.25C4.91645 20.1875 4.59465 20.0718 4.33887 19.8623L4.2334 19.7666C3.96381 19.497 3.8125 19.1312 3.8125 18.75V14.25C3.8125 13.9165 3.92816 13.5946 4.1377 13.3389L4.2334 13.2334C4.50298 12.9638 4.86875 12.8125 5.25 12.8125ZM14.25 12.8125H18.75C19.0835 12.8125 19.4054 12.9282 19.6611 13.1377L19.7666 13.2334C20.0362 13.503 20.1875 13.8688 20.1875 14.25V18.75C20.1875 19.0835 20.0718 19.4054 19.8623 19.6611L19.7666 19.7666C19.497 20.0362 19.1312 20.1875 18.75 20.1875H14.25C13.9165 20.1875 13.5946 20.0718 13.3389 19.8623L13.2334 19.7666C12.9638 19.497 12.8125 19.1312 12.8125 18.75V14.25C12.8125 13.9165 12.9282 13.5946 13.1377 13.3389L13.2334 13.2334C13.503 12.9638 13.8688 12.8125 14.25 12.8125ZM5.1875 18.8125H9.8125V14.1875H5.1875V18.8125ZM14.1875 18.8125H18.8125V14.1875H14.1875V18.8125ZM5.25 3.8125H9.75C10.0835 3.8125 10.4054 3.92816 10.6611 4.1377L10.7666 4.2334C11.0362 4.50298 11.1875 4.86875 11.1875 5.25V9.75C11.1875 10.1312 11.0362 10.497 10.7666 10.7666C10.497 11.0362 10.1312 11.1875 9.75 11.1875H5.25C4.91645 11.1875 4.59465 11.0718 4.33887 10.8623L4.2334 10.7666C3.96381 10.497 3.8125 10.1312 3.8125 9.75V5.25L3.81934 5.1084C3.84726 4.8262 3.958 4.55823 4.1377 4.33887L4.2334 4.2334C4.50298 3.96381 4.86875 3.8125 5.25 3.8125ZM14.25 3.8125H18.75C19.0835 3.8125 19.4054 3.92816 19.6611 4.1377L19.7666 4.2334C20.0362 4.50298 20.1875 4.86875 20.1875 5.25V9.75C20.1875 10.0835 20.0718 10.4054 19.8623 10.6611L19.7666 10.7666C19.497 11.0362 19.1312 11.1875 18.75 11.1875H14.25C13.9165 11.1875 13.5946 11.0718 13.3389 10.8623L13.2334 10.7666C12.9638 10.497 12.8125 10.1312 12.8125 9.75V5.25C12.8125 4.91645 12.9282 4.59465 13.1377 4.33887L13.2334 4.2334C13.503 3.96381 13.8688 3.8125 14.25 3.8125ZM5.1875 9.8125H9.8125V5.1875H5.1875V9.8125ZM14.1875 9.8125H18.8125V5.1875H14.1875V9.8125Z"
      fill="#6B7280"
      stroke="#6B7280"
      strokeWidth="0.125"
    />
  </svg>
);

export const AppointmentsActiveIcon = () => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5 0.5625C13.6368 0.5625 13.7697 0.602903 13.8818 0.677734L13.9863 0.763672C14.1153 0.892603 14.1875 1.06766 14.1875 1.25V2.0625H16.5C16.8335 2.0625 17.1554 2.17816 17.4111 2.3877L17.5166 2.4834C17.7862 2.75298 17.9375 3.11875 17.9375 3.5V18.5C17.9375 18.8335 17.8218 19.1554 17.6123 19.4111L17.5166 19.5166C17.247 19.7862 16.8812 19.9375 16.5 19.9375H1.5C1.16645 19.9375 0.844647 19.8218 0.588867 19.6123L0.483398 19.5166C0.213815 19.247 0.0625 18.8812 0.0625 18.5V3.5C0.0625 3.16645 0.178162 2.84465 0.387695 2.58887L0.483398 2.4834C0.752982 2.21381 1.11875 2.0625 1.5 2.0625H3.8125V1.25C3.8125 1.11318 3.8529 0.980319 3.92773 0.868164L4.01367 0.763672C4.1426 0.634741 4.31766 0.5625 4.5 0.5625C4.63682 0.5625 4.76968 0.602903 4.88184 0.677734L4.98633 0.763672C5.11526 0.892603 5.1875 1.06766 5.1875 1.25V2.0625H12.8125V1.25C12.8125 1.11318 12.8529 0.980319 12.9277 0.868164L13.0137 0.763672C13.1426 0.634741 13.3177 0.5625 13.5 0.5625ZM1.4375 6.5625H16.5625V3.4375H14.1875V4.25C14.1875 4.38682 14.1471 4.51968 14.0723 4.63184L13.9863 4.73633C13.8574 4.86526 13.6823 4.9375 13.5 4.9375C13.3632 4.9375 13.2303 4.8971 13.1182 4.82227L13.0137 4.73633C12.8847 4.6074 12.8125 4.43234 12.8125 4.25V3.4375H5.1875V4.25C5.1875 4.38682 5.1471 4.51968 5.07227 4.63184L4.98633 4.73633C4.8574 4.86526 4.68234 4.9375 4.5 4.9375C4.36318 4.9375 4.23032 4.8971 4.11816 4.82227L4.01367 4.73633C3.88474 4.6074 3.8125 4.43234 3.8125 4.25V3.4375H1.4375V6.5625Z"
      fill="#7E3AF2"
      stroke="#7E3AF2"
      stroke-width="0.125"
    />
  </svg>
);

export const AppointmentsInactiveIcon = () => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5 0.5625C13.6368 0.5625 13.7697 0.602903 13.8818 0.677734L13.9863 0.763672C14.1153 0.892603 14.1875 1.06766 14.1875 1.25V2.0625H16.5C16.8335 2.0625 17.1554 2.17816 17.4111 2.3877L17.5166 2.4834C17.7862 2.75298 17.9375 3.11875 17.9375 3.5V18.5C17.9375 18.8335 17.8218 19.1554 17.6123 19.4111L17.5166 19.5166C17.247 19.7862 16.8812 19.9375 16.5 19.9375H1.5C1.16645 19.9375 0.844647 19.8218 0.588867 19.6123L0.483398 19.5166C0.213815 19.247 0.0625 18.8812 0.0625 18.5V3.5C0.0625 3.16645 0.178162 2.84465 0.387695 2.58887L0.483398 2.4834C0.752982 2.21381 1.11875 2.0625 1.5 2.0625H3.8125V1.25C3.8125 1.11318 3.8529 0.980319 3.92773 0.868164L4.01367 0.763672C4.1426 0.634741 4.31766 0.5625 4.5 0.5625C4.63682 0.5625 4.76968 0.602903 4.88184 0.677734L4.98633 0.763672C5.11526 0.892603 5.1875 1.06766 5.1875 1.25V2.0625H12.8125V1.25C12.8125 1.11318 12.8529 0.980319 12.9277 0.868164L13.0137 0.763672C13.1426 0.634741 13.3177 0.5625 13.5 0.5625ZM1.4375 18.5625H16.5625V7.9375H1.4375V18.5625ZM1.4375 6.5625H16.5625V3.4375H14.1875V4.25C14.1875 4.38682 14.1471 4.51968 14.0723 4.63184L13.9863 4.73633C13.8574 4.86526 13.6823 4.9375 13.5 4.9375C13.3632 4.9375 13.2303 4.8971 13.1182 4.82227L13.0137 4.73633C12.8847 4.6074 12.8125 4.43234 12.8125 4.25V3.4375H5.1875V4.25C5.1875 4.38682 5.1471 4.51968 5.07227 4.63184L4.98633 4.73633C4.8574 4.86526 4.68234 4.9375 4.5 4.9375C4.36318 4.9375 4.23032 4.8971 4.11816 4.82227L4.01367 4.73633C3.88474 4.6074 3.8125 4.43234 3.8125 4.25V3.4375H1.4375V6.5625Z"
      fill="#6B7280"
      stroke="#6B7280"
      stroke-width="0.125"
    />
  </svg>
);

export const DarkLogo = () => (
  <svg
    width="150"
    height="40"
    viewBox="0 0 150 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1_3)">
      <path
        d="M40.027 33.5238H34.7952V8.41454L40.027 5.79031V33.5238Z"
        fill="#491972"
      />
      <path
        d="M59.9572 33.5237H54.7282V32.1908C53.7785 33.1822 52.1151 33.9431 50.2573 33.9431C46.5445 33.9431 42.829 31.6604 42.829 26.8285C42.829 22.4159 46.3918 20.211 50.9016 20.211C52.7205 20.211 53.8951 20.5887 54.731 21.008V20.0166C54.731 18.6087 53.7841 17.4702 51.8902 17.4702C49.4992 17.4702 48.2524 17.8117 46.4335 18.8003L44.423 15.1486C46.7334 13.8185 48.6689 13.1326 51.8902 13.1326C56.6999 13.1326 59.9628 15.6429 59.9628 20.1305V33.521L59.96 33.5237H59.9572ZM54.731 27.6672V25.154C53.8202 24.582 52.951 24.3209 51.0932 24.3209C49.1216 24.3209 48.0635 25.2345 48.0635 26.8313C48.0635 28.2392 48.8577 29.4916 51.0932 29.4916C52.801 29.4916 54.1645 28.6196 54.731 27.6672Z"
        fill="#491972"
      />
      <path
        d="M76.3301 14.5405L74.9666 19.6751C74.1336 18.9142 73.1089 18.3782 71.937 18.3782C69.8876 18.3782 68.5658 19.253 68.5658 22.7158V33.521H63.334V13.5547H68.5658V14.8848C69.4766 13.9323 70.8012 13.1353 72.6562 13.1353C74.364 13.1353 75.6498 13.8213 76.3301 14.5433V14.5405Z"
        fill="#491972"
      />
      <path
        d="M83.8363 8.91162C83.8363 10.55 82.47 11.9163 80.8427 11.9163C79.2154 11.9163 77.8492 10.5445 77.8492 8.91162C77.8492 7.27877 79.2154 5.90695 80.8427 5.90695C82.47 5.90695 83.8363 7.27877 83.8363 8.91162ZM83.4559 33.5238H78.2241V13.5547H83.4559V33.5238Z"
        fill="#491972"
      />
      <path
        d="M99.5205 34.2097L92.5448 17.0509C91.9755 15.679 91.2563 13.6658 90.9925 12.6383V33.5238H88.1517V6.89276H91.4479L97.6988 22.8325C98.3431 24.4292 99.2873 26.9035 99.5927 28.006C99.9343 26.8646 100.881 24.3904 101.487 22.8325L107.815 6.89276H111.037V33.5238H108.196V12.6383C107.929 13.6658 107.171 15.6429 106.605 17.0509L99.5177 34.2097H99.5205Z"
        fill="#F482EE"
      />
      <path
        d="M131.317 22.9491C131.317 23.635 131.281 24.0516 131.206 24.507H117.94C118.207 28.7696 120.214 31.4688 123.472 31.4688C125.782 31.4688 127.148 30.7829 128.967 29.5666L130.295 31.6243C127.904 33.1433 126.165 33.9431 123.169 33.9431C119.531 33.9431 115.094 31.28 115.094 23.4434C115.094 17.087 118.582 13.1326 123.319 13.1326C128.509 13.1326 131.314 17.2397 131.314 22.9463L131.317 22.9491ZM128.667 22.1882C128.437 18.3088 126.774 15.6096 123.286 15.6096C120.331 15.6096 118.282 17.7395 117.94 22.1882H128.667Z"
        fill="#F482EE"
      />
      <path
        d="M150 33.5238H147.156V31.0884C145.754 32.6101 143.86 33.9431 141.169 33.9431C137.19 33.9431 134.044 30.8995 134.044 23.86C134.044 16.8204 137.376 13.1326 141.547 13.1326C144.049 13.1326 145.754 14.1962 147.156 15.7929V7.38706L150 5.79031V33.5238ZM147.156 28.578V18.6087C146.06 16.9342 144.124 15.6041 141.777 15.6041C138.481 15.6041 136.848 18.4588 136.848 23.8239C136.848 28.8446 138.742 31.4688 141.889 31.4688C144.01 31.4688 145.754 30.3275 147.156 28.578Z"
        fill="#F482EE"
      />
      <path
        d="M9.71934 29.836C11.2161 31.255 13.0322 32.3297 15.0511 32.9434C13.01 32.338 11.1689 31.2606 9.65547 29.836H9.71934ZM25.4841 24.3904C24.0734 26.4981 21.6797 27.8893 18.9638 27.8893C18.8555 27.8893 18.7472 27.8893 18.6334 27.881C18.4334 28.5169 18.214 29.1306 17.9725 29.7249C17.7336 30.3247 17.4726 30.8968 17.1894 31.4466C16.87 32.0714 16.5257 32.6629 16.1619 33.2183C17.0366 33.3988 17.9447 33.4932 18.8694 33.4932C24.7677 33.4932 29.7828 29.6916 31.6045 24.3904H25.4813H25.4841ZM22.8793 7.05661C22.8044 7.02884 22.7294 7.0094 22.6544 6.98719C21.4825 6.65395 20.2468 6.47623 18.9666 6.47623C18.2835 6.47623 17.6142 6.52899 16.9561 6.62341C17.2754 7.20934 17.5726 7.82305 17.8419 8.47008C18.0808 9.03658 18.3029 9.62529 18.5056 10.2334C18.7083 10.8388 18.8888 11.4664 19.0499 12.1107C21.7352 12.1412 24.0984 13.5297 25.4924 15.6235H31.6267C30.2494 11.5442 26.9837 8.33956 22.8738 7.05661H22.8793ZM15.912 6.82612C13.546 7.37596 11.4161 8.55894 9.70823 10.1751H7.75048C7.22286 10.1751 6.79243 10.6083 6.79243 11.1387C6.79243 11.6719 7.22286 12.1051 7.75048 12.1051H10.533C11.2189 11.3609 11.9992 10.7139 12.8573 10.1751C14.0569 9.4198 15.4093 8.88107 16.8506 8.61448C16.5618 7.98411 16.248 7.38707 15.912 6.82612ZM17.5531 10.3279C15.14 10.6778 13.0045 11.9274 11.5021 13.7213H6.20927C5.68165 13.7213 5.25122 14.1545 5.25122 14.6849C5.25122 15.182 5.62611 15.593 6.10652 15.643C6.13985 15.6513 6.17317 15.6513 6.20649 15.6513H12.4102C12.8962 14.9071 13.5071 14.2573 14.2097 13.7213C15.3205 12.8716 16.6645 12.3106 18.1252 12.1551C17.9558 11.5275 17.7642 10.9166 17.5504 10.3251H17.5531V10.3279ZM4.46534 17.2675C3.93772 17.2675 3.50729 17.7007 3.50729 18.2339C3.50729 18.7643 3.93772 19.1975 4.46534 19.1975H11.1439C11.2133 18.5254 11.3661 17.8784 11.591 17.2675H4.46534ZM11.8465 29.1084C11.3855 28.7446 10.9468 28.3392 10.5441 27.906H8.11982C8.09205 27.906 8.06983 27.906 8.04761 27.9115C8.0254 27.9115 8.00318 27.9143 7.98097 27.9227C7.51444 27.9865 7.16177 28.3892 7.16177 28.8696C7.16177 29.4028 7.58942 29.8332 8.12259 29.8332H9.72767C11.2245 31.255 13.0378 32.3297 15.0594 32.9434C15.0678 32.9434 15.0705 32.9489 15.0761 32.9489C15.4649 32.4158 15.8314 31.8493 16.173 31.2383C14.5762 30.8385 13.11 30.1026 11.8493 29.1084H11.8465ZM14.1514 26.2287C13.4766 25.7066 12.8934 25.0735 12.4185 24.3626H2.5909C1.97997 24.3626 1.48567 24.793 1.48567 25.3262C1.48567 25.8566 1.97997 26.2898 2.5909 26.2898H11.5133C12.8962 27.9421 14.8151 29.1223 16.9977 29.5749C17.2532 29.0029 17.4809 28.4058 17.6948 27.7866C16.3757 27.5728 15.165 27.0229 14.1514 26.2287ZM11.1495 20.8164H1.18854C0.533175 20.8164 0 21.2469 0 21.78C0 22.3104 0.533175 22.7436 1.18854 22.7436H11.5938C11.3689 22.1327 11.2161 21.4857 11.1495 20.8164Z"
        fill="url(#paint0_linear_1_3)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1_3"
        x1="0"
        y1="19.9848"
        x2="31.6276"
        y2="19.9848"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F482EE" />
        <stop offset="0.5" stopColor="#662D91" />
        <stop offset="1" stopColor="#5DF2FE" />
      </linearGradient>
      <clipPath id="clip0_1_3">
        <rect width="150" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
